// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  createMeasurement,
  createTransaction,
  dataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPost,
  dataRouterPostTransactionsFromMqttV1DataMqttTransactionsPost,
  dataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPost,
  schemaOnlyControllerMqttPayloads,
  schemaOnlyPartnerMqttPayloads,
  getLatestMeasurementsForSite,
  getLatestMeasurementForSite,
  getLatestTransactionsForSite,
  getRecentTransactionsForSite,
  getCalculatedUclForSiteInArrow,
  getPowerOverviewForSiteInArrow,
  getSocOverviewForSiteInArrow,
  getTransactionStatsForSite,
  getDriverSummariesForSite,
  getActiveTransactionsWithEnergyForSite,
  getActiveDriverSessions,
  overwriteDriverPreferencesForTransaction,
  endTransactionAsGhost,
  getLatestMeasurementForAsset,
  getMeasurementsForSite,
  getMeasurementsForSiteQuarterHourly,
  getMeasurementsForAsset,
  getMeasurementsForSiteInArrow,
  getMeasurementsForAssetInArrow,
  getMeasurementsForAssetInArrowInterpolated,
  getTransactionsWithEventsForSite,
  getTransactionsForSite,
  getLifecycleAroundActiveTransactions,
  listFailedMessages,
  listSites,
  createSite,
  deleteSite,
  getSite,
  patchSite,
  updateSite,
  validateSite,
  activateSite,
  deactivateSite,
  shadowSite,
  configureSite,
  updateContractConfiguration,
  updateRevenueConfiguration,
  getSiteConfigurationSchema,
  getSiteEnergy,
  getBillingReport,
  getAllPartnersInvoicingOverview,
  getPartnerInvoicingReport,
  createMqttToken,
  inviteUser,
  resendUserInvite,
  listIdentities,
  setIdentityReadOnly,
  deleteIdentity,
  clientAuthenticated,
  clientLogin,
  completeUserRegistration,
  adminLoginAsPartner,
  adminLoginAsDriver,
  registerSiteOwner,
  getJwks,
  getOpenidConfiguration,
  listControllerTokens,
  createControllerTokenAsAdmin,
  revokeControllerToken,
  createControllerImagePullToken,
  getControllerConfiguration,
  schemaOnlyControllerAdmin,
  schemaOnlyDeviceInfo,
  reportControllerAlerts,
  listSiteAlerts,
  getSiteAlertSettings,
  updateSiteAlertSettings,
  listSiteIoConfigurations,
  getSiteIoConfiguration,
  patchSiteIoConfiguration,
  createSiteIoConfiguration,
  getControllerConfigurationStatus,
  getModbusRegisterCatalog,
  getPartners,
  createPartner,
  partnerRouterDeletePartnerV1PartnerPartnerIdDelete,
  partnerRouterGetPartnerV1PartnerPartnerIdGet,
  partnerRouterUpdatePartnerV1PartnerPartnerIdPut,
  partnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPost,
  getPartnerBranding,
  getAggregatedSchedule,
  getAggregatedSocSchedule,
  getEnergySchedule,
  getAssetEnergySchedule,
  getOptimizationResult,
  schemaOnlyAdvice,
  schemaOnlyPolicies,
  getDayAHeadPrices,
  getDayAHeadPricesWithForecast,
  optimizationsGetTasks,
  optimizationsDeleteTask,
  optimizationsGetTask,
  optimizationsCreateTask,
  optimizationsUpdateTask,
  predictionsGetTasks,
  predictionsDeleteTask,
  predictionsGetTask,
  predictionsCreateTask,
  predictionsUpdateTask,
  forecastingGetTasks,
  forecastingDeleteTask,
  forecastingGetTask,
  forecastingCreateTask,
  forecastingUpdateTask,
  getSiteForecasts,
  getDevicePredictionInsightsInArrow,
  getImbalancePriceInsights,
  getImbalanceForecastMetrics,
  createForecastingTask,
  forecastingGetGlobalTasks,
  reschedulePendingForecastingTasks,
  listProfiles,
  createProfile,
  deleteProfile,
  getProfile,
  patchProfile,
  webhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPost,
  loginWithPassword,
  startDriverLogin,
  requestPasswordReset,
  resetPassword,
  getAuthenticatedDriver,
  batchCreateDrivers,
  getDrivers,
  createDriver,
  setDriverProfile,
  setDriverCar,
  markOnboardingAsSeen,
  setDriverEmail,
  setDriverEmailNotifications,
  setDriverPassword,
  deleteDriver,
  getDriver,
  updateDriver,
  requestMagicLink,
  verifyMagicLink,
  verifyMagicLinkToken,
  getDriverActiveTransaction,
  getDriverTransactionMeasurements,
  submitDriverInput,
  getDriverSchedule,
  getEvVehicleMakes,
  getEvVehicleModels,
  getEvVehicleVariants,
  getEvVehicle,
  pxcAdminRouterCreateTokenV1PxcTokensPost,
  pxcAdminRouterDeleteTokenV1PxcTokensTokenIdDelete,
  getOcppConfigurations,
  createOcppConfiguration,
  getOcppActiveSocketsForSite,
  getOcppConfiguration,
  deleteOcppConfiguration,
  updateOcppConfiguration,
  updateSocketToAssetMap,
  getSocketMappingSuggestions,
  listOcppMessages,
  diagnoseOcppTransactionLinking,
  benefitReportRouterListReportsV1BenefitReportsSiteIdGet,
  benefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGet,
  alertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGet,
  alertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPost,
  alertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDelete,
  alertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGet,
  alertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPut,
  requestSiteGoLive,
} from "../sdk.gen";
import {
  queryOptions,
  type UseMutationOptions,
  infiniteQueryOptions,
  type InfiniteData,
  type DefaultError,
} from "@tanstack/react-query";
import type {
  CreateMeasurementData,
  CreateMeasurementError,
  CreateMeasurementResponse,
  CreateTransactionData,
  CreateTransactionError,
  CreateTransactionResponse,
  DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostData,
  DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostError,
  DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostData,
  DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostError,
  DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostData,
  DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostError,
  SchemaOnlyControllerMqttPayloadsData,
  SchemaOnlyControllerMqttPayloadsError,
  SchemaOnlyPartnerMqttPayloadsData,
  SchemaOnlyPartnerMqttPayloadsError,
  GetLatestMeasurementsForSiteData,
  GetLatestMeasurementsForSiteError,
  GetLatestMeasurementsForSiteResponse,
  GetLatestMeasurementForSiteData,
  GetLatestTransactionsForSiteData,
  GetLatestTransactionsForSiteError,
  GetLatestTransactionsForSiteResponse,
  GetRecentTransactionsForSiteData,
  GetCalculatedUclForSiteInArrowData,
  GetCalculatedUclForSiteInArrowError,
  GetPowerOverviewForSiteInArrowData,
  GetPowerOverviewForSiteInArrowError,
  GetSocOverviewForSiteInArrowData,
  GetSocOverviewForSiteInArrowError,
  GetTransactionStatsForSiteData,
  GetTransactionStatsForSiteError,
  GetTransactionStatsForSiteResponse,
  GetDriverSummariesForSiteData,
  GetDriverSummariesForSiteError,
  GetDriverSummariesForSiteResponse,
  GetActiveTransactionsWithEnergyForSiteData,
  GetActiveTransactionsWithEnergyForSiteError,
  GetActiveTransactionsWithEnergyForSiteResponse,
  GetActiveDriverSessionsData,
  OverwriteDriverPreferencesForTransactionData,
  OverwriteDriverPreferencesForTransactionError,
  OverwriteDriverPreferencesForTransactionResponse,
  EndTransactionAsGhostData,
  EndTransactionAsGhostError,
  EndTransactionAsGhostResponse,
  GetLatestMeasurementForAssetData,
  GetMeasurementsForSiteData,
  GetMeasurementsForSiteError,
  GetMeasurementsForSiteResponse,
  GetMeasurementsForSiteQuarterHourlyData,
  GetMeasurementsForSiteQuarterHourlyError,
  GetMeasurementsForAssetData,
  GetMeasurementsForAssetError,
  GetMeasurementsForAssetResponse,
  GetMeasurementsForSiteInArrowData,
  GetMeasurementsForSiteInArrowError,
  GetMeasurementsForAssetInArrowData,
  GetMeasurementsForAssetInArrowError,
  GetMeasurementsForAssetInArrowInterpolatedData,
  GetMeasurementsForAssetInArrowInterpolatedError,
  GetTransactionsWithEventsForSiteData,
  GetTransactionsWithEventsForSiteError,
  GetTransactionsWithEventsForSiteResponse,
  GetTransactionsForSiteData,
  GetTransactionsForSiteError,
  GetTransactionsForSiteResponse,
  GetLifecycleAroundActiveTransactionsData,
  GetLifecycleAroundActiveTransactionsError,
  GetLifecycleAroundActiveTransactionsResponse,
  ListFailedMessagesData,
  ListFailedMessagesError,
  ListFailedMessagesResponse,
  ListSitesData,
  ListSitesError,
  ListSitesResponse,
  CreateSiteData,
  CreateSiteError,
  CreateSiteResponse,
  DeleteSiteData,
  DeleteSiteError,
  GetSiteData,
  PatchSiteData,
  PatchSiteError,
  PatchSiteResponse,
  UpdateSiteData,
  UpdateSiteError,
  UpdateSiteResponse,
  ValidateSiteData,
  ActivateSiteData,
  ActivateSiteError,
  ActivateSiteResponse,
  DeactivateSiteData,
  DeactivateSiteError,
  DeactivateSiteResponse,
  ShadowSiteData,
  ShadowSiteError,
  ShadowSiteResponse,
  ConfigureSiteData,
  ConfigureSiteError,
  ConfigureSiteResponse,
  UpdateContractConfigurationData,
  UpdateContractConfigurationError,
  UpdateContractConfigurationResponse,
  UpdateRevenueConfigurationData,
  UpdateRevenueConfigurationError,
  UpdateRevenueConfigurationResponse,
  GetSiteConfigurationSchemaData,
  GetSiteEnergyData,
  GetSiteEnergyError,
  GetSiteEnergyResponse,
  GetBillingReportData,
  GetAllPartnersInvoicingOverviewData,
  GetPartnerInvoicingReportData,
  CreateMqttTokenData,
  CreateMqttTokenError,
  CreateMqttTokenResponse,
  InviteUserData,
  InviteUserError,
  InviteUserResponse,
  ResendUserInviteData,
  ResendUserInviteError,
  ResendUserInviteResponse,
  ListIdentitiesData,
  SetIdentityReadOnlyData,
  SetIdentityReadOnlyError,
  SetIdentityReadOnlyResponse,
  DeleteIdentityData,
  DeleteIdentityError,
  DeleteIdentityResponse,
  ClientAuthenticatedData,
  ClientLoginData,
  ClientLoginError,
  ClientLoginResponse,
  CompleteUserRegistrationData,
  CompleteUserRegistrationError,
  CompleteUserRegistrationResponse,
  AdminLoginAsPartnerData,
  AdminLoginAsPartnerResponse,
  AdminLoginAsDriverData,
  AdminLoginAsDriverResponse,
  RegisterSiteOwnerData,
  RegisterSiteOwnerError,
  RegisterSiteOwnerResponse,
  GetJwksData,
  GetOpenidConfigurationData,
  ListControllerTokensData,
  CreateControllerTokenAsAdminData,
  CreateControllerTokenAsAdminError,
  CreateControllerTokenAsAdminResponse,
  RevokeControllerTokenData,
  RevokeControllerTokenError,
  RevokeControllerTokenResponse,
  CreateControllerImagePullTokenData,
  CreateControllerImagePullTokenResponse,
  GetControllerConfigurationData,
  SchemaOnlyControllerAdminData,
  SchemaOnlyControllerAdminResponse,
  SchemaOnlyDeviceInfoData,
  SchemaOnlyDeviceInfoError,
  ReportControllerAlertsData,
  ReportControllerAlertsError,
  ReportControllerAlertsResponse,
  ListSiteAlertsData,
  ListSiteAlertsError,
  ListSiteAlertsResponse,
  GetSiteAlertSettingsData,
  UpdateSiteAlertSettingsData,
  UpdateSiteAlertSettingsError,
  UpdateSiteAlertSettingsResponse,
  ListSiteIoConfigurationsData,
  GetSiteIoConfigurationData,
  PatchSiteIoConfigurationData,
  PatchSiteIoConfigurationError,
  PatchSiteIoConfigurationResponse,
  CreateSiteIoConfigurationData,
  CreateSiteIoConfigurationError,
  CreateSiteIoConfigurationResponse,
  GetControllerConfigurationStatusData,
  GetModbusRegisterCatalogData,
  GetPartnersData,
  CreatePartnerData,
  CreatePartnerError,
  CreatePartnerResponse,
  PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteData,
  PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteError,
  PartnerRouterGetPartnerV1PartnerPartnerIdGetData,
  PartnerRouterUpdatePartnerV1PartnerPartnerIdPutData,
  PartnerRouterUpdatePartnerV1PartnerPartnerIdPutError,
  PartnerRouterUpdatePartnerV1PartnerPartnerIdPutResponse,
  PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostData,
  PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostError,
  PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostResponse,
  GetPartnerBrandingData,
  GetAggregatedScheduleData,
  GetAggregatedScheduleError,
  GetAggregatedSocScheduleData,
  GetAggregatedSocScheduleError,
  GetEnergyScheduleData,
  GetAssetEnergyScheduleData,
  GetOptimizationResultData,
  SchemaOnlyAdviceData,
  SchemaOnlyAdviceError,
  SchemaOnlyAdviceResponse,
  SchemaOnlyPoliciesData,
  GetDayAHeadPricesData,
  GetDayAHeadPricesWithForecastData,
  OptimizationsGetTasksData,
  OptimizationsGetTasksError,
  OptimizationsGetTasksResponse,
  OptimizationsDeleteTaskData,
  OptimizationsDeleteTaskError,
  OptimizationsGetTaskData,
  OptimizationsCreateTaskData,
  OptimizationsCreateTaskError,
  OptimizationsCreateTaskResponse,
  OptimizationsUpdateTaskData,
  OptimizationsUpdateTaskError,
  OptimizationsUpdateTaskResponse,
  PredictionsGetTasksData,
  PredictionsGetTasksError,
  PredictionsGetTasksResponse,
  PredictionsDeleteTaskData,
  PredictionsDeleteTaskError,
  PredictionsGetTaskData,
  PredictionsCreateTaskData,
  PredictionsCreateTaskError,
  PredictionsCreateTaskResponse,
  PredictionsUpdateTaskData,
  PredictionsUpdateTaskError,
  PredictionsUpdateTaskResponse,
  ForecastingGetTasksData,
  ForecastingGetTasksError,
  ForecastingGetTasksResponse,
  ForecastingDeleteTaskData,
  ForecastingDeleteTaskError,
  ForecastingGetTaskData,
  ForecastingCreateTaskData,
  ForecastingCreateTaskError,
  ForecastingCreateTaskResponse,
  ForecastingUpdateTaskData,
  ForecastingUpdateTaskError,
  ForecastingUpdateTaskResponse,
  GetSiteForecastsData,
  GetSiteForecastsError,
  GetSiteForecastsResponse,
  GetDevicePredictionInsightsInArrowData,
  GetDevicePredictionInsightsInArrowError,
  GetImbalancePriceInsightsData,
  GetImbalancePriceInsightsError,
  GetImbalancePriceInsightsResponse,
  GetImbalanceForecastMetricsData,
  CreateForecastingTaskData,
  CreateForecastingTaskError,
  ForecastingGetGlobalTasksData,
  ForecastingGetGlobalTasksError,
  ForecastingGetGlobalTasksResponse,
  ReschedulePendingForecastingTasksData,
  ListProfilesData,
  ListProfilesError,
  ListProfilesResponse,
  CreateProfileData,
  CreateProfileError,
  CreateProfileResponse,
  DeleteProfileData,
  DeleteProfileError,
  DeleteProfileResponse,
  GetProfileData,
  PatchProfileData,
  PatchProfileError,
  PatchProfileResponse,
  WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostData,
  WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostError,
  WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostResponse,
  LoginWithPasswordData,
  LoginWithPasswordError,
  LoginWithPasswordResponse,
  StartDriverLoginData,
  StartDriverLoginError,
  StartDriverLoginResponse,
  RequestPasswordResetData,
  RequestPasswordResetError,
  RequestPasswordResetResponse,
  ResetPasswordData,
  ResetPasswordError,
  ResetPasswordResponse,
  GetAuthenticatedDriverData,
  BatchCreateDriversData,
  BatchCreateDriversError,
  BatchCreateDriversResponse,
  GetDriversData,
  CreateDriverData,
  CreateDriverError,
  CreateDriverResponse,
  SetDriverProfileData,
  SetDriverProfileError,
  SetDriverProfileResponse,
  SetDriverCarData,
  SetDriverCarError,
  SetDriverCarResponse,
  MarkOnboardingAsSeenData,
  MarkOnboardingAsSeenResponse,
  SetDriverEmailData,
  SetDriverEmailError,
  SetDriverEmailResponse,
  SetDriverEmailNotificationsData,
  SetDriverEmailNotificationsError,
  SetDriverEmailNotificationsResponse,
  SetDriverPasswordData,
  SetDriverPasswordError,
  DeleteDriverData,
  DeleteDriverError,
  GetDriverData,
  UpdateDriverData,
  UpdateDriverError,
  UpdateDriverResponse,
  RequestMagicLinkData,
  RequestMagicLinkError,
  RequestMagicLinkResponse,
  VerifyMagicLinkData,
  VerifyMagicLinkError,
  VerifyMagicLinkResponse,
  VerifyMagicLinkTokenData,
  VerifyMagicLinkTokenError,
  VerifyMagicLinkTokenResponse,
  GetDriverActiveTransactionData,
  GetDriverTransactionMeasurementsData,
  SubmitDriverInputData,
  SubmitDriverInputError,
  SubmitDriverInputResponse,
  GetDriverScheduleData,
  GetEvVehicleMakesData,
  GetEvVehicleModelsData,
  GetEvVehicleVariantsData,
  GetEvVehicleData,
  PxcAdminRouterCreateTokenV1PxcTokensPostData,
  PxcAdminRouterCreateTokenV1PxcTokensPostError,
  PxcAdminRouterCreateTokenV1PxcTokensPostResponse,
  PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteData,
  PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteError,
  PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteResponse,
  GetOcppConfigurationsData,
  CreateOcppConfigurationData,
  CreateOcppConfigurationError,
  CreateOcppConfigurationResponse,
  GetOcppActiveSocketsForSiteData,
  GetOcppConfigurationData,
  DeleteOcppConfigurationData,
  DeleteOcppConfigurationError,
  UpdateOcppConfigurationData,
  UpdateOcppConfigurationError,
  UpdateOcppConfigurationResponse,
  UpdateSocketToAssetMapData,
  UpdateSocketToAssetMapError,
  UpdateSocketToAssetMapResponse,
  GetSocketMappingSuggestionsData,
  ListOcppMessagesData,
  ListOcppMessagesError,
  ListOcppMessagesResponse,
  DiagnoseOcppTransactionLinkingData,
  BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData,
  BenefitReportRouterListReportsV1BenefitReportsSiteIdGetError,
  BenefitReportRouterListReportsV1BenefitReportsSiteIdGetResponse,
  BenefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetData,
  AlertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetData,
  AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostData,
  AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostError,
  AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostResponse,
  AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteData,
  AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteError,
  AlertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetData,
  AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutData,
  AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutError,
  AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutResponse,
  RequestSiteGoLiveData,
  RequestSiteGoLiveError,
  RequestSiteGoLiveResponse,
} from "../types.gen";
import { client as _heyApiClient } from "../client.gen";

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const createMeasurementQueryKey = (
  options: Options<CreateMeasurementData>,
) => createQueryKey("createMeasurement", options);

export const createMeasurementOptions = (
  options: Options<CreateMeasurementData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createMeasurement({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createMeasurementQueryKey(options),
  });
};

export const createMeasurementMutation = (
  options?: Partial<Options<CreateMeasurementData>>,
): UseMutationOptions<
  CreateMeasurementResponse,
  CreateMeasurementError,
  Options<CreateMeasurementData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateMeasurementResponse,
    CreateMeasurementError,
    Options<CreateMeasurementData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createMeasurement({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const createTransactionQueryKey = (
  options: Options<CreateTransactionData>,
) => createQueryKey("createTransaction", options);

export const createTransactionOptions = (
  options: Options<CreateTransactionData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createTransaction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createTransactionQueryKey(options),
  });
};

export const createTransactionMutation = (
  options?: Partial<Options<CreateTransactionData>>,
): UseMutationOptions<
  CreateTransactionResponse,
  CreateTransactionError,
  Options<CreateTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateTransactionResponse,
    CreateTransactionError,
    Options<CreateTransactionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createTransaction({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const dataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostQueryKey =
  (
    options: Options<DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostData>,
  ) =>
    createQueryKey(
      "dataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPost",
      options,
    );

export const dataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostOptions =
  (
    options: Options<DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await dataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
          });
        return data;
      },
      queryKey:
        dataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostQueryKey(
          options,
        ),
    });
  };

export const dataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostMutation =
  (
    options?: Partial<
      Options<DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostData>
    >,
  ): UseMutationOptions<
    unknown,
    DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostError,
    Options<DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      unknown,
      DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostError,
      Options<DataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPostData>
    > = {
      mutationFn: async (localOptions) => {
        const { data } =
          await dataRouterPostMeasurementsFromMqttV1DataMqttMeasurementsPost({
            ...options,
            ...localOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const dataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostQueryKey =
  (
    options: Options<DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostData>,
  ) =>
    createQueryKey(
      "dataRouterPostTransactionsFromMqttV1DataMqttTransactionsPost",
      options,
    );

export const dataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostOptions =
  (
    options: Options<DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await dataRouterPostTransactionsFromMqttV1DataMqttTransactionsPost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
          });
        return data;
      },
      queryKey:
        dataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostQueryKey(
          options,
        ),
    });
  };

export const dataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostMutation =
  (
    options?: Partial<
      Options<DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostData>
    >,
  ): UseMutationOptions<
    unknown,
    DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostError,
    Options<DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      unknown,
      DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostError,
      Options<DataRouterPostTransactionsFromMqttV1DataMqttTransactionsPostData>
    > = {
      mutationFn: async (localOptions) => {
        const { data } =
          await dataRouterPostTransactionsFromMqttV1DataMqttTransactionsPost({
            ...options,
            ...localOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const dataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostQueryKey =
  (
    options: Options<DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostData>,
  ) =>
    createQueryKey(
      "dataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPost",
      options,
    );

export const dataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostOptions =
  (
    options: Options<DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await dataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPost(
            {
              ...options,
              ...queryKey[0],
              signal,
              throwOnError: true,
            },
          );
        return data;
      },
      queryKey:
        dataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostQueryKey(
          options,
        ),
    });
  };

export const dataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostMutation =
  (
    options?: Partial<
      Options<DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostData>
    >,
  ): UseMutationOptions<
    unknown,
    DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostError,
    Options<DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      unknown,
      DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostError,
      Options<DataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPostData>
    > = {
      mutationFn: async (localOptions) => {
        const { data } =
          await dataRouterPostTransactionEventsFromMqttV1DataMqttTransactionEventsPost(
            {
              ...options,
              ...localOptions,
              throwOnError: true,
            },
          );
        return data;
      },
    };
    return mutationOptions;
  };

export const schemaOnlyControllerMqttPayloadsQueryKey = (
  options: Options<SchemaOnlyControllerMqttPayloadsData>,
) => createQueryKey("schemaOnlyControllerMqttPayloads", options);

export const schemaOnlyControllerMqttPayloadsOptions = (
  options: Options<SchemaOnlyControllerMqttPayloadsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schemaOnlyControllerMqttPayloads({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: schemaOnlyControllerMqttPayloadsQueryKey(options),
  });
};

export const schemaOnlyControllerMqttPayloadsMutation = (
  options?: Partial<Options<SchemaOnlyControllerMqttPayloadsData>>,
): UseMutationOptions<
  unknown,
  SchemaOnlyControllerMqttPayloadsError,
  Options<SchemaOnlyControllerMqttPayloadsData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SchemaOnlyControllerMqttPayloadsError,
    Options<SchemaOnlyControllerMqttPayloadsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await schemaOnlyControllerMqttPayloads({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const schemaOnlyPartnerMqttPayloadsQueryKey = (
  options: Options<SchemaOnlyPartnerMqttPayloadsData>,
) => createQueryKey("schemaOnlyPartnerMqttPayloads", options);

export const schemaOnlyPartnerMqttPayloadsOptions = (
  options: Options<SchemaOnlyPartnerMqttPayloadsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schemaOnlyPartnerMqttPayloads({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: schemaOnlyPartnerMqttPayloadsQueryKey(options),
  });
};

export const schemaOnlyPartnerMqttPayloadsMutation = (
  options?: Partial<Options<SchemaOnlyPartnerMqttPayloadsData>>,
): UseMutationOptions<
  unknown,
  SchemaOnlyPartnerMqttPayloadsError,
  Options<SchemaOnlyPartnerMqttPayloadsData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SchemaOnlyPartnerMqttPayloadsError,
    Options<SchemaOnlyPartnerMqttPayloadsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await schemaOnlyPartnerMqttPayloads({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLatestMeasurementsForSiteQueryKey = (
  options: Options<GetLatestMeasurementsForSiteData>,
) => createQueryKey("getLatestMeasurementsForSite", options);

export const getLatestMeasurementsForSiteOptions = (
  options: Options<GetLatestMeasurementsForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestMeasurementsForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestMeasurementsForSiteQueryKey(options),
  });
};

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = queryKey[0];
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const getLatestMeasurementsForSiteInfiniteQueryKey = (
  options: Options<GetLatestMeasurementsForSiteData>,
): QueryKey<Options<GetLatestMeasurementsForSiteData>> =>
  createQueryKey("getLatestMeasurementsForSite", options, true);

export const getLatestMeasurementsForSiteInfiniteOptions = (
  options: Options<GetLatestMeasurementsForSiteData>,
) => {
  return infiniteQueryOptions<
    GetLatestMeasurementsForSiteResponse,
    GetLatestMeasurementsForSiteError,
    InfiniteData<GetLatestMeasurementsForSiteResponse>,
    QueryKey<Options<GetLatestMeasurementsForSiteData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetLatestMeasurementsForSiteData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetLatestMeasurementsForSiteData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  before: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLatestMeasurementsForSite({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLatestMeasurementsForSiteInfiniteQueryKey(options),
    },
  );
};

export const getLatestMeasurementForSiteQueryKey = (
  options: Options<GetLatestMeasurementForSiteData>,
) => createQueryKey("getLatestMeasurementForSite", options);

export const getLatestMeasurementForSiteOptions = (
  options: Options<GetLatestMeasurementForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestMeasurementForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestMeasurementForSiteQueryKey(options),
  });
};

export const getLatestTransactionsForSiteQueryKey = (
  options: Options<GetLatestTransactionsForSiteData>,
) => createQueryKey("getLatestTransactionsForSite", options);

export const getLatestTransactionsForSiteOptions = (
  options: Options<GetLatestTransactionsForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestTransactionsForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestTransactionsForSiteQueryKey(options),
  });
};

export const getLatestTransactionsForSiteInfiniteQueryKey = (
  options: Options<GetLatestTransactionsForSiteData>,
): QueryKey<Options<GetLatestTransactionsForSiteData>> =>
  createQueryKey("getLatestTransactionsForSite", options, true);

export const getLatestTransactionsForSiteInfiniteOptions = (
  options: Options<GetLatestTransactionsForSiteData>,
) => {
  return infiniteQueryOptions<
    GetLatestTransactionsForSiteResponse,
    GetLatestTransactionsForSiteError,
    InfiniteData<GetLatestTransactionsForSiteResponse>,
    QueryKey<Options<GetLatestTransactionsForSiteData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetLatestTransactionsForSiteData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetLatestTransactionsForSiteData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  before: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLatestTransactionsForSite({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLatestTransactionsForSiteInfiniteQueryKey(options),
    },
  );
};

export const getRecentTransactionsForSiteQueryKey = (
  options: Options<GetRecentTransactionsForSiteData>,
) => createQueryKey("getRecentTransactionsForSite", options);

export const getRecentTransactionsForSiteOptions = (
  options: Options<GetRecentTransactionsForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRecentTransactionsForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRecentTransactionsForSiteQueryKey(options),
  });
};

export const getCalculatedUclForSiteInArrowQueryKey = (
  options: Options<GetCalculatedUclForSiteInArrowData>,
) => createQueryKey("getCalculatedUclForSiteInArrow", options);

export const getCalculatedUclForSiteInArrowOptions = (
  options: Options<GetCalculatedUclForSiteInArrowData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCalculatedUclForSiteInArrow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCalculatedUclForSiteInArrowQueryKey(options),
  });
};

export const getCalculatedUclForSiteInArrowInfiniteQueryKey = (
  options: Options<GetCalculatedUclForSiteInArrowData>,
): QueryKey<Options<GetCalculatedUclForSiteInArrowData>> =>
  createQueryKey("getCalculatedUclForSiteInArrow", options, true);

export const getCalculatedUclForSiteInArrowInfiniteOptions = (
  options: Options<GetCalculatedUclForSiteInArrowData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetCalculatedUclForSiteInArrowError,
    InfiniteData<unknown>,
    QueryKey<Options<GetCalculatedUclForSiteInArrowData>>,
    | string
    | Pick<
        QueryKey<Options<GetCalculatedUclForSiteInArrowData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetCalculatedUclForSiteInArrowData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getCalculatedUclForSiteInArrow({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getCalculatedUclForSiteInArrowInfiniteQueryKey(options),
    },
  );
};

export const getPowerOverviewForSiteInArrowQueryKey = (
  options: Options<GetPowerOverviewForSiteInArrowData>,
) => createQueryKey("getPowerOverviewForSiteInArrow", options);

export const getPowerOverviewForSiteInArrowOptions = (
  options: Options<GetPowerOverviewForSiteInArrowData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPowerOverviewForSiteInArrow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPowerOverviewForSiteInArrowQueryKey(options),
  });
};

export const getPowerOverviewForSiteInArrowInfiniteQueryKey = (
  options: Options<GetPowerOverviewForSiteInArrowData>,
): QueryKey<Options<GetPowerOverviewForSiteInArrowData>> =>
  createQueryKey("getPowerOverviewForSiteInArrow", options, true);

export const getPowerOverviewForSiteInArrowInfiniteOptions = (
  options: Options<GetPowerOverviewForSiteInArrowData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetPowerOverviewForSiteInArrowError,
    InfiniteData<unknown>,
    QueryKey<Options<GetPowerOverviewForSiteInArrowData>>,
    | string
    | Pick<
        QueryKey<Options<GetPowerOverviewForSiteInArrowData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetPowerOverviewForSiteInArrowData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getPowerOverviewForSiteInArrow({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getPowerOverviewForSiteInArrowInfiniteQueryKey(options),
    },
  );
};

export const getSocOverviewForSiteInArrowQueryKey = (
  options: Options<GetSocOverviewForSiteInArrowData>,
) => createQueryKey("getSocOverviewForSiteInArrow", options);

export const getSocOverviewForSiteInArrowOptions = (
  options: Options<GetSocOverviewForSiteInArrowData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSocOverviewForSiteInArrow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSocOverviewForSiteInArrowQueryKey(options),
  });
};

export const getSocOverviewForSiteInArrowInfiniteQueryKey = (
  options: Options<GetSocOverviewForSiteInArrowData>,
): QueryKey<Options<GetSocOverviewForSiteInArrowData>> =>
  createQueryKey("getSocOverviewForSiteInArrow", options, true);

export const getSocOverviewForSiteInArrowInfiniteOptions = (
  options: Options<GetSocOverviewForSiteInArrowData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetSocOverviewForSiteInArrowError,
    InfiniteData<unknown>,
    QueryKey<Options<GetSocOverviewForSiteInArrowData>>,
    | string
    | Pick<
        QueryKey<Options<GetSocOverviewForSiteInArrowData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetSocOverviewForSiteInArrowData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getSocOverviewForSiteInArrow({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getSocOverviewForSiteInArrowInfiniteQueryKey(options),
    },
  );
};

export const getTransactionStatsForSiteQueryKey = (
  options: Options<GetTransactionStatsForSiteData>,
) => createQueryKey("getTransactionStatsForSite", options);

export const getTransactionStatsForSiteOptions = (
  options: Options<GetTransactionStatsForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTransactionStatsForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTransactionStatsForSiteQueryKey(options),
  });
};

export const getTransactionStatsForSiteInfiniteQueryKey = (
  options: Options<GetTransactionStatsForSiteData>,
): QueryKey<Options<GetTransactionStatsForSiteData>> =>
  createQueryKey("getTransactionStatsForSite", options, true);

export const getTransactionStatsForSiteInfiniteOptions = (
  options: Options<GetTransactionStatsForSiteData>,
) => {
  return infiniteQueryOptions<
    GetTransactionStatsForSiteResponse,
    GetTransactionStatsForSiteError,
    InfiniteData<GetTransactionStatsForSiteResponse>,
    QueryKey<Options<GetTransactionStatsForSiteData>>,
    | string
    | Pick<
        QueryKey<Options<GetTransactionStatsForSiteData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetTransactionStatsForSiteData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getTransactionStatsForSite({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getTransactionStatsForSiteInfiniteQueryKey(options),
    },
  );
};

export const getDriverSummariesForSiteQueryKey = (
  options: Options<GetDriverSummariesForSiteData>,
) => createQueryKey("getDriverSummariesForSite", options);

export const getDriverSummariesForSiteOptions = (
  options: Options<GetDriverSummariesForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriverSummariesForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDriverSummariesForSiteQueryKey(options),
  });
};

export const getDriverSummariesForSiteInfiniteQueryKey = (
  options: Options<GetDriverSummariesForSiteData>,
): QueryKey<Options<GetDriverSummariesForSiteData>> =>
  createQueryKey("getDriverSummariesForSite", options, true);

export const getDriverSummariesForSiteInfiniteOptions = (
  options: Options<GetDriverSummariesForSiteData>,
) => {
  return infiniteQueryOptions<
    GetDriverSummariesForSiteResponse,
    GetDriverSummariesForSiteError,
    InfiniteData<GetDriverSummariesForSiteResponse>,
    QueryKey<Options<GetDriverSummariesForSiteData>>,
    | string
    | Pick<
        QueryKey<Options<GetDriverSummariesForSiteData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetDriverSummariesForSiteData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getDriverSummariesForSite({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getDriverSummariesForSiteInfiniteQueryKey(options),
    },
  );
};

export const getActiveTransactionsWithEnergyForSiteQueryKey = (
  options: Options<GetActiveTransactionsWithEnergyForSiteData>,
) => createQueryKey("getActiveTransactionsWithEnergyForSite", options);

export const getActiveTransactionsWithEnergyForSiteOptions = (
  options: Options<GetActiveTransactionsWithEnergyForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActiveTransactionsWithEnergyForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActiveTransactionsWithEnergyForSiteQueryKey(options),
  });
};

export const getActiveTransactionsWithEnergyForSiteInfiniteQueryKey = (
  options: Options<GetActiveTransactionsWithEnergyForSiteData>,
): QueryKey<Options<GetActiveTransactionsWithEnergyForSiteData>> =>
  createQueryKey("getActiveTransactionsWithEnergyForSite", options, true);

export const getActiveTransactionsWithEnergyForSiteInfiniteOptions = (
  options: Options<GetActiveTransactionsWithEnergyForSiteData>,
) => {
  return infiniteQueryOptions<
    GetActiveTransactionsWithEnergyForSiteResponse,
    GetActiveTransactionsWithEnergyForSiteError,
    InfiniteData<GetActiveTransactionsWithEnergyForSiteResponse>,
    QueryKey<Options<GetActiveTransactionsWithEnergyForSiteData>>,
    | string
    | Pick<
        QueryKey<Options<GetActiveTransactionsWithEnergyForSiteData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetActiveTransactionsWithEnergyForSiteData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getActiveTransactionsWithEnergyForSite({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getActiveTransactionsWithEnergyForSiteInfiniteQueryKey(options),
    },
  );
};

export const getActiveDriverSessionsQueryKey = (
  options?: Options<GetActiveDriverSessionsData>,
) => createQueryKey("getActiveDriverSessions", options);

export const getActiveDriverSessionsOptions = (
  options?: Options<GetActiveDriverSessionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActiveDriverSessions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getActiveDriverSessionsQueryKey(options),
  });
};

export const overwriteDriverPreferencesForTransactionQueryKey = (
  options: Options<OverwriteDriverPreferencesForTransactionData>,
) => createQueryKey("overwriteDriverPreferencesForTransaction", options);

export const overwriteDriverPreferencesForTransactionOptions = (
  options: Options<OverwriteDriverPreferencesForTransactionData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await overwriteDriverPreferencesForTransaction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: overwriteDriverPreferencesForTransactionQueryKey(options),
  });
};

export const overwriteDriverPreferencesForTransactionMutation = (
  options?: Partial<Options<OverwriteDriverPreferencesForTransactionData>>,
): UseMutationOptions<
  OverwriteDriverPreferencesForTransactionResponse,
  OverwriteDriverPreferencesForTransactionError,
  Options<OverwriteDriverPreferencesForTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    OverwriteDriverPreferencesForTransactionResponse,
    OverwriteDriverPreferencesForTransactionError,
    Options<OverwriteDriverPreferencesForTransactionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await overwriteDriverPreferencesForTransaction({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const endTransactionAsGhostQueryKey = (
  options: Options<EndTransactionAsGhostData>,
) => createQueryKey("endTransactionAsGhost", options);

export const endTransactionAsGhostOptions = (
  options: Options<EndTransactionAsGhostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await endTransactionAsGhost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: endTransactionAsGhostQueryKey(options),
  });
};

export const endTransactionAsGhostMutation = (
  options?: Partial<Options<EndTransactionAsGhostData>>,
): UseMutationOptions<
  EndTransactionAsGhostResponse,
  EndTransactionAsGhostError,
  Options<EndTransactionAsGhostData>
> => {
  const mutationOptions: UseMutationOptions<
    EndTransactionAsGhostResponse,
    EndTransactionAsGhostError,
    Options<EndTransactionAsGhostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await endTransactionAsGhost({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLatestMeasurementForAssetQueryKey = (
  options: Options<GetLatestMeasurementForAssetData>,
) => createQueryKey("getLatestMeasurementForAsset", options);

export const getLatestMeasurementForAssetOptions = (
  options: Options<GetLatestMeasurementForAssetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestMeasurementForAsset({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLatestMeasurementForAssetQueryKey(options),
  });
};

export const getMeasurementsForSiteQueryKey = (
  options: Options<GetMeasurementsForSiteData>,
) => createQueryKey("getMeasurementsForSite", options);

export const getMeasurementsForSiteOptions = (
  options: Options<GetMeasurementsForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeasurementsForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeasurementsForSiteQueryKey(options),
  });
};

export const getMeasurementsForSiteInfiniteQueryKey = (
  options: Options<GetMeasurementsForSiteData>,
): QueryKey<Options<GetMeasurementsForSiteData>> =>
  createQueryKey("getMeasurementsForSite", options, true);

export const getMeasurementsForSiteInfiniteOptions = (
  options: Options<GetMeasurementsForSiteData>,
) => {
  return infiniteQueryOptions<
    GetMeasurementsForSiteResponse,
    GetMeasurementsForSiteError,
    InfiniteData<GetMeasurementsForSiteResponse>,
    QueryKey<Options<GetMeasurementsForSiteData>>,
    | string
    | Pick<
        QueryKey<Options<GetMeasurementsForSiteData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetMeasurementsForSiteData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getMeasurementsForSite({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getMeasurementsForSiteInfiniteQueryKey(options),
    },
  );
};

export const getMeasurementsForSiteMutation = (
  options?: Partial<Options<GetMeasurementsForSiteData>>,
): UseMutationOptions<
  GetMeasurementsForSiteResponse,
  GetMeasurementsForSiteError,
  Options<GetMeasurementsForSiteData>
> => {
  const mutationOptions: UseMutationOptions<
    GetMeasurementsForSiteResponse,
    GetMeasurementsForSiteError,
    Options<GetMeasurementsForSiteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getMeasurementsForSite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMeasurementsForSiteQuarterHourlyQueryKey = (
  options: Options<GetMeasurementsForSiteQuarterHourlyData>,
) => createQueryKey("getMeasurementsForSiteQuarterHourly", options);

export const getMeasurementsForSiteQuarterHourlyOptions = (
  options: Options<GetMeasurementsForSiteQuarterHourlyData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeasurementsForSiteQuarterHourly({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeasurementsForSiteQuarterHourlyQueryKey(options),
  });
};

export const getMeasurementsForSiteQuarterHourlyInfiniteQueryKey = (
  options: Options<GetMeasurementsForSiteQuarterHourlyData>,
): QueryKey<Options<GetMeasurementsForSiteQuarterHourlyData>> =>
  createQueryKey("getMeasurementsForSiteQuarterHourly", options, true);

export const getMeasurementsForSiteQuarterHourlyInfiniteOptions = (
  options: Options<GetMeasurementsForSiteQuarterHourlyData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetMeasurementsForSiteQuarterHourlyError,
    InfiniteData<unknown>,
    QueryKey<Options<GetMeasurementsForSiteQuarterHourlyData>>,
    | string
    | Pick<
        QueryKey<Options<GetMeasurementsForSiteQuarterHourlyData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetMeasurementsForSiteQuarterHourlyData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getMeasurementsForSiteQuarterHourly({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getMeasurementsForSiteQuarterHourlyInfiniteQueryKey(options),
    },
  );
};

export const getMeasurementsForSiteQuarterHourlyMutation = (
  options?: Partial<Options<GetMeasurementsForSiteQuarterHourlyData>>,
): UseMutationOptions<
  unknown,
  GetMeasurementsForSiteQuarterHourlyError,
  Options<GetMeasurementsForSiteQuarterHourlyData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    GetMeasurementsForSiteQuarterHourlyError,
    Options<GetMeasurementsForSiteQuarterHourlyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getMeasurementsForSiteQuarterHourly({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMeasurementsForAssetQueryKey = (
  options: Options<GetMeasurementsForAssetData>,
) => createQueryKey("getMeasurementsForAsset", options);

export const getMeasurementsForAssetOptions = (
  options: Options<GetMeasurementsForAssetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeasurementsForAsset({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeasurementsForAssetQueryKey(options),
  });
};

export const getMeasurementsForAssetInfiniteQueryKey = (
  options: Options<GetMeasurementsForAssetData>,
): QueryKey<Options<GetMeasurementsForAssetData>> =>
  createQueryKey("getMeasurementsForAsset", options, true);

export const getMeasurementsForAssetInfiniteOptions = (
  options: Options<GetMeasurementsForAssetData>,
) => {
  return infiniteQueryOptions<
    GetMeasurementsForAssetResponse,
    GetMeasurementsForAssetError,
    InfiniteData<GetMeasurementsForAssetResponse>,
    QueryKey<Options<GetMeasurementsForAssetData>>,
    | string
    | Pick<
        QueryKey<Options<GetMeasurementsForAssetData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetMeasurementsForAssetData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getMeasurementsForAsset({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getMeasurementsForAssetInfiniteQueryKey(options),
    },
  );
};

export const getMeasurementsForAssetMutation = (
  options?: Partial<Options<GetMeasurementsForAssetData>>,
): UseMutationOptions<
  GetMeasurementsForAssetResponse,
  GetMeasurementsForAssetError,
  Options<GetMeasurementsForAssetData>
> => {
  const mutationOptions: UseMutationOptions<
    GetMeasurementsForAssetResponse,
    GetMeasurementsForAssetError,
    Options<GetMeasurementsForAssetData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getMeasurementsForAsset({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMeasurementsForSiteInArrowQueryKey = (
  options: Options<GetMeasurementsForSiteInArrowData>,
) => createQueryKey("getMeasurementsForSiteInArrow", options);

export const getMeasurementsForSiteInArrowOptions = (
  options: Options<GetMeasurementsForSiteInArrowData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeasurementsForSiteInArrow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeasurementsForSiteInArrowQueryKey(options),
  });
};

export const getMeasurementsForSiteInArrowInfiniteQueryKey = (
  options: Options<GetMeasurementsForSiteInArrowData>,
): QueryKey<Options<GetMeasurementsForSiteInArrowData>> =>
  createQueryKey("getMeasurementsForSiteInArrow", options, true);

export const getMeasurementsForSiteInArrowInfiniteOptions = (
  options: Options<GetMeasurementsForSiteInArrowData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetMeasurementsForSiteInArrowError,
    InfiniteData<unknown>,
    QueryKey<Options<GetMeasurementsForSiteInArrowData>>,
    | string
    | Pick<
        QueryKey<Options<GetMeasurementsForSiteInArrowData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetMeasurementsForSiteInArrowData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getMeasurementsForSiteInArrow({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getMeasurementsForSiteInArrowInfiniteQueryKey(options),
    },
  );
};

export const getMeasurementsForSiteInArrowMutation = (
  options?: Partial<Options<GetMeasurementsForSiteInArrowData>>,
): UseMutationOptions<
  unknown,
  GetMeasurementsForSiteInArrowError,
  Options<GetMeasurementsForSiteInArrowData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    GetMeasurementsForSiteInArrowError,
    Options<GetMeasurementsForSiteInArrowData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getMeasurementsForSiteInArrow({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMeasurementsForAssetInArrowQueryKey = (
  options: Options<GetMeasurementsForAssetInArrowData>,
) => createQueryKey("getMeasurementsForAssetInArrow", options);

export const getMeasurementsForAssetInArrowOptions = (
  options: Options<GetMeasurementsForAssetInArrowData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeasurementsForAssetInArrow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeasurementsForAssetInArrowQueryKey(options),
  });
};

export const getMeasurementsForAssetInArrowInfiniteQueryKey = (
  options: Options<GetMeasurementsForAssetInArrowData>,
): QueryKey<Options<GetMeasurementsForAssetInArrowData>> =>
  createQueryKey("getMeasurementsForAssetInArrow", options, true);

export const getMeasurementsForAssetInArrowInfiniteOptions = (
  options: Options<GetMeasurementsForAssetInArrowData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetMeasurementsForAssetInArrowError,
    InfiniteData<unknown>,
    QueryKey<Options<GetMeasurementsForAssetInArrowData>>,
    | string
    | Pick<
        QueryKey<Options<GetMeasurementsForAssetInArrowData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetMeasurementsForAssetInArrowData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getMeasurementsForAssetInArrow({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getMeasurementsForAssetInArrowInfiniteQueryKey(options),
    },
  );
};

export const getMeasurementsForAssetInArrowMutation = (
  options?: Partial<Options<GetMeasurementsForAssetInArrowData>>,
): UseMutationOptions<
  unknown,
  GetMeasurementsForAssetInArrowError,
  Options<GetMeasurementsForAssetInArrowData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    GetMeasurementsForAssetInArrowError,
    Options<GetMeasurementsForAssetInArrowData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getMeasurementsForAssetInArrow({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMeasurementsForAssetInArrowInterpolatedQueryKey = (
  options: Options<GetMeasurementsForAssetInArrowInterpolatedData>,
) => createQueryKey("getMeasurementsForAssetInArrowInterpolated", options);

export const getMeasurementsForAssetInArrowInterpolatedOptions = (
  options: Options<GetMeasurementsForAssetInArrowInterpolatedData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeasurementsForAssetInArrowInterpolated({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeasurementsForAssetInArrowInterpolatedQueryKey(options),
  });
};

export const getMeasurementsForAssetInArrowInterpolatedInfiniteQueryKey = (
  options: Options<GetMeasurementsForAssetInArrowInterpolatedData>,
): QueryKey<Options<GetMeasurementsForAssetInArrowInterpolatedData>> =>
  createQueryKey("getMeasurementsForAssetInArrowInterpolated", options, true);

export const getMeasurementsForAssetInArrowInterpolatedInfiniteOptions = (
  options: Options<GetMeasurementsForAssetInArrowInterpolatedData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetMeasurementsForAssetInArrowInterpolatedError,
    InfiniteData<unknown>,
    QueryKey<Options<GetMeasurementsForAssetInArrowInterpolatedData>>,
    | string
    | Pick<
        QueryKey<Options<GetMeasurementsForAssetInArrowInterpolatedData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetMeasurementsForAssetInArrowInterpolatedData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getMeasurementsForAssetInArrowInterpolated({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getMeasurementsForAssetInArrowInterpolatedInfiniteQueryKey(options),
    },
  );
};

export const getMeasurementsForAssetInArrowInterpolatedMutation = (
  options?: Partial<Options<GetMeasurementsForAssetInArrowInterpolatedData>>,
): UseMutationOptions<
  unknown,
  GetMeasurementsForAssetInArrowInterpolatedError,
  Options<GetMeasurementsForAssetInArrowInterpolatedData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    GetMeasurementsForAssetInArrowInterpolatedError,
    Options<GetMeasurementsForAssetInArrowInterpolatedData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getMeasurementsForAssetInArrowInterpolated({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTransactionsWithEventsForSiteQueryKey = (
  options: Options<GetTransactionsWithEventsForSiteData>,
) => createQueryKey("getTransactionsWithEventsForSite", options);

export const getTransactionsWithEventsForSiteOptions = (
  options: Options<GetTransactionsWithEventsForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTransactionsWithEventsForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTransactionsWithEventsForSiteQueryKey(options),
  });
};

export const getTransactionsWithEventsForSiteInfiniteQueryKey = (
  options: Options<GetTransactionsWithEventsForSiteData>,
): QueryKey<Options<GetTransactionsWithEventsForSiteData>> =>
  createQueryKey("getTransactionsWithEventsForSite", options, true);

export const getTransactionsWithEventsForSiteInfiniteOptions = (
  options: Options<GetTransactionsWithEventsForSiteData>,
) => {
  return infiniteQueryOptions<
    GetTransactionsWithEventsForSiteResponse,
    GetTransactionsWithEventsForSiteError,
    InfiniteData<GetTransactionsWithEventsForSiteResponse>,
    QueryKey<Options<GetTransactionsWithEventsForSiteData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetTransactionsWithEventsForSiteData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetTransactionsWithEventsForSiteData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getTransactionsWithEventsForSite({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getTransactionsWithEventsForSiteInfiniteQueryKey(options),
    },
  );
};

export const getTransactionsForSiteQueryKey = (
  options: Options<GetTransactionsForSiteData>,
) => createQueryKey("getTransactionsForSite", options);

export const getTransactionsForSiteOptions = (
  options: Options<GetTransactionsForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTransactionsForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTransactionsForSiteQueryKey(options),
  });
};

export const getTransactionsForSiteInfiniteQueryKey = (
  options: Options<GetTransactionsForSiteData>,
): QueryKey<Options<GetTransactionsForSiteData>> =>
  createQueryKey("getTransactionsForSite", options, true);

export const getTransactionsForSiteInfiniteOptions = (
  options: Options<GetTransactionsForSiteData>,
) => {
  return infiniteQueryOptions<
    GetTransactionsForSiteResponse,
    GetTransactionsForSiteError,
    InfiniteData<GetTransactionsForSiteResponse>,
    QueryKey<Options<GetTransactionsForSiteData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetTransactionsForSiteData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetTransactionsForSiteData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getTransactionsForSite({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getTransactionsForSiteInfiniteQueryKey(options),
    },
  );
};

export const getLifecycleAroundActiveTransactionsQueryKey = (
  options: Options<GetLifecycleAroundActiveTransactionsData>,
) => createQueryKey("getLifecycleAroundActiveTransactions", options);

export const getLifecycleAroundActiveTransactionsOptions = (
  options: Options<GetLifecycleAroundActiveTransactionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLifecycleAroundActiveTransactions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLifecycleAroundActiveTransactionsQueryKey(options),
  });
};

export const getLifecycleAroundActiveTransactionsInfiniteQueryKey = (
  options: Options<GetLifecycleAroundActiveTransactionsData>,
): QueryKey<Options<GetLifecycleAroundActiveTransactionsData>> =>
  createQueryKey("getLifecycleAroundActiveTransactions", options, true);

export const getLifecycleAroundActiveTransactionsInfiniteOptions = (
  options: Options<GetLifecycleAroundActiveTransactionsData>,
) => {
  return infiniteQueryOptions<
    GetLifecycleAroundActiveTransactionsResponse,
    GetLifecycleAroundActiveTransactionsError,
    InfiniteData<GetLifecycleAroundActiveTransactionsResponse>,
    QueryKey<Options<GetLifecycleAroundActiveTransactionsData>>,
    | string
    | Pick<
        QueryKey<Options<GetLifecycleAroundActiveTransactionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetLifecycleAroundActiveTransactionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  before: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLifecycleAroundActiveTransactions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLifecycleAroundActiveTransactionsInfiniteQueryKey(options),
    },
  );
};

export const listFailedMessagesQueryKey = (
  options?: Options<ListFailedMessagesData>,
) => createQueryKey("listFailedMessages", options);

export const listFailedMessagesOptions = (
  options?: Options<ListFailedMessagesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listFailedMessages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listFailedMessagesQueryKey(options),
  });
};

export const listFailedMessagesInfiniteQueryKey = (
  options?: Options<ListFailedMessagesData>,
): QueryKey<Options<ListFailedMessagesData>> =>
  createQueryKey("listFailedMessages", options, true);

export const listFailedMessagesInfiniteOptions = (
  options?: Options<ListFailedMessagesData>,
) => {
  return infiniteQueryOptions<
    ListFailedMessagesResponse,
    ListFailedMessagesError,
    InfiniteData<ListFailedMessagesResponse>,
    QueryKey<Options<ListFailedMessagesData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListFailedMessagesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListFailedMessagesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listFailedMessages({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listFailedMessagesInfiniteQueryKey(options),
    },
  );
};

export const listSitesQueryKey = (options?: Options<ListSitesData>) =>
  createQueryKey("listSites", options);

export const listSitesOptions = (options?: Options<ListSitesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSites({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSitesQueryKey(options),
  });
};

export const listSitesInfiniteQueryKey = (
  options?: Options<ListSitesData>,
): QueryKey<Options<ListSitesData>> =>
  createQueryKey("listSites", options, true);

export const listSitesInfiniteOptions = (options?: Options<ListSitesData>) => {
  return infiniteQueryOptions<
    ListSitesResponse,
    ListSitesError,
    InfiniteData<ListSitesResponse>,
    QueryKey<Options<ListSitesData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListSitesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListSitesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listSites({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listSitesInfiniteQueryKey(options),
    },
  );
};

export const createSiteQueryKey = (options: Options<CreateSiteData>) =>
  createQueryKey("createSite", options);

export const createSiteOptions = (options: Options<CreateSiteData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createSiteQueryKey(options),
  });
};

export const createSiteMutation = (
  options?: Partial<Options<CreateSiteData>>,
): UseMutationOptions<
  CreateSiteResponse,
  CreateSiteError,
  Options<CreateSiteData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSiteResponse,
    CreateSiteError,
    Options<CreateSiteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createSite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteSiteMutation = (
  options?: Partial<Options<DeleteSiteData>>,
): UseMutationOptions<unknown, DeleteSiteError, Options<DeleteSiteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteSiteError,
    Options<DeleteSiteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteSite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSiteQueryKey = (options: Options<GetSiteData>) =>
  createQueryKey("getSite", options);

export const getSiteOptions = (options: Options<GetSiteData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSiteQueryKey(options),
  });
};

export const patchSiteMutation = (
  options?: Partial<Options<PatchSiteData>>,
): UseMutationOptions<
  PatchSiteResponse,
  PatchSiteError,
  Options<PatchSiteData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchSiteResponse,
    PatchSiteError,
    Options<PatchSiteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await patchSite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateSiteMutation = (
  options?: Partial<Options<UpdateSiteData>>,
): UseMutationOptions<
  UpdateSiteResponse,
  UpdateSiteError,
  Options<UpdateSiteData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateSiteResponse,
    UpdateSiteError,
    Options<UpdateSiteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateSite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const validateSiteQueryKey = (options: Options<ValidateSiteData>) =>
  createQueryKey("validateSite", options);

export const validateSiteOptions = (options: Options<ValidateSiteData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await validateSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: validateSiteQueryKey(options),
  });
};

export const activateSiteQueryKey = (options: Options<ActivateSiteData>) =>
  createQueryKey("activateSite", options);

export const activateSiteOptions = (options: Options<ActivateSiteData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await activateSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: activateSiteQueryKey(options),
  });
};

export const activateSiteMutation = (
  options?: Partial<Options<ActivateSiteData>>,
): UseMutationOptions<
  ActivateSiteResponse,
  ActivateSiteError,
  Options<ActivateSiteData>
> => {
  const mutationOptions: UseMutationOptions<
    ActivateSiteResponse,
    ActivateSiteError,
    Options<ActivateSiteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await activateSite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deactivateSiteQueryKey = (options: Options<DeactivateSiteData>) =>
  createQueryKey("deactivateSite", options);

export const deactivateSiteOptions = (options: Options<DeactivateSiteData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await deactivateSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: deactivateSiteQueryKey(options),
  });
};

export const deactivateSiteMutation = (
  options?: Partial<Options<DeactivateSiteData>>,
): UseMutationOptions<
  DeactivateSiteResponse,
  DeactivateSiteError,
  Options<DeactivateSiteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeactivateSiteResponse,
    DeactivateSiteError,
    Options<DeactivateSiteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deactivateSite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const shadowSiteQueryKey = (options: Options<ShadowSiteData>) =>
  createQueryKey("shadowSite", options);

export const shadowSiteOptions = (options: Options<ShadowSiteData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await shadowSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: shadowSiteQueryKey(options),
  });
};

export const shadowSiteMutation = (
  options?: Partial<Options<ShadowSiteData>>,
): UseMutationOptions<
  ShadowSiteResponse,
  ShadowSiteError,
  Options<ShadowSiteData>
> => {
  const mutationOptions: UseMutationOptions<
    ShadowSiteResponse,
    ShadowSiteError,
    Options<ShadowSiteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await shadowSite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const configureSiteMutation = (
  options?: Partial<Options<ConfigureSiteData>>,
): UseMutationOptions<
  ConfigureSiteResponse,
  ConfigureSiteError,
  Options<ConfigureSiteData>
> => {
  const mutationOptions: UseMutationOptions<
    ConfigureSiteResponse,
    ConfigureSiteError,
    Options<ConfigureSiteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await configureSite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateContractConfigurationMutation = (
  options?: Partial<Options<UpdateContractConfigurationData>>,
): UseMutationOptions<
  UpdateContractConfigurationResponse,
  UpdateContractConfigurationError,
  Options<UpdateContractConfigurationData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateContractConfigurationResponse,
    UpdateContractConfigurationError,
    Options<UpdateContractConfigurationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateContractConfiguration({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateRevenueConfigurationMutation = (
  options?: Partial<Options<UpdateRevenueConfigurationData>>,
): UseMutationOptions<
  UpdateRevenueConfigurationResponse,
  UpdateRevenueConfigurationError,
  Options<UpdateRevenueConfigurationData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateRevenueConfigurationResponse,
    UpdateRevenueConfigurationError,
    Options<UpdateRevenueConfigurationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateRevenueConfiguration({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSiteConfigurationSchemaQueryKey = (
  options?: Options<GetSiteConfigurationSchemaData>,
) => createQueryKey("getSiteConfigurationSchema", options);

export const getSiteConfigurationSchemaOptions = (
  options?: Options<GetSiteConfigurationSchemaData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSiteConfigurationSchema({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSiteConfigurationSchemaQueryKey(options),
  });
};

export const getSiteEnergyQueryKey = (options: Options<GetSiteEnergyData>) =>
  createQueryKey("getSiteEnergy", options);

export const getSiteEnergyOptions = (options: Options<GetSiteEnergyData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSiteEnergy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSiteEnergyQueryKey(options),
  });
};

export const getSiteEnergyInfiniteQueryKey = (
  options: Options<GetSiteEnergyData>,
): QueryKey<Options<GetSiteEnergyData>> =>
  createQueryKey("getSiteEnergy", options, true);

export const getSiteEnergyInfiniteOptions = (
  options: Options<GetSiteEnergyData>,
) => {
  return infiniteQueryOptions<
    GetSiteEnergyResponse,
    GetSiteEnergyError,
    InfiniteData<GetSiteEnergyResponse>,
    QueryKey<Options<GetSiteEnergyData>>,
    | string
    | Pick<
        QueryKey<Options<GetSiteEnergyData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetSiteEnergyData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getSiteEnergy({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getSiteEnergyInfiniteQueryKey(options),
    },
  );
};

export const getBillingReportQueryKey = (
  options: Options<GetBillingReportData>,
) => createQueryKey("getBillingReport", options);

export const getBillingReportOptions = (
  options: Options<GetBillingReportData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBillingReport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBillingReportQueryKey(options),
  });
};

export const getAllPartnersInvoicingOverviewQueryKey = (
  options?: Options<GetAllPartnersInvoicingOverviewData>,
) => createQueryKey("getAllPartnersInvoicingOverview", options);

export const getAllPartnersInvoicingOverviewOptions = (
  options?: Options<GetAllPartnersInvoicingOverviewData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllPartnersInvoicingOverview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllPartnersInvoicingOverviewQueryKey(options),
  });
};

export const getPartnerInvoicingReportQueryKey = (
  options: Options<GetPartnerInvoicingReportData>,
) => createQueryKey("getPartnerInvoicingReport", options);

export const getPartnerInvoicingReportOptions = (
  options: Options<GetPartnerInvoicingReportData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPartnerInvoicingReport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPartnerInvoicingReportQueryKey(options),
  });
};

export const createMqttTokenQueryKey = (
  options: Options<CreateMqttTokenData>,
) => createQueryKey("createMqttToken", options);

export const createMqttTokenOptions = (
  options: Options<CreateMqttTokenData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createMqttToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createMqttTokenQueryKey(options),
  });
};

export const createMqttTokenMutation = (
  options?: Partial<Options<CreateMqttTokenData>>,
): UseMutationOptions<
  CreateMqttTokenResponse,
  CreateMqttTokenError,
  Options<CreateMqttTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateMqttTokenResponse,
    CreateMqttTokenError,
    Options<CreateMqttTokenData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createMqttToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const inviteUserQueryKey = (options: Options<InviteUserData>) =>
  createQueryKey("inviteUser", options);

export const inviteUserOptions = (options: Options<InviteUserData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await inviteUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: inviteUserQueryKey(options),
  });
};

export const inviteUserMutation = (
  options?: Partial<Options<InviteUserData>>,
): UseMutationOptions<
  InviteUserResponse,
  InviteUserError,
  Options<InviteUserData>
> => {
  const mutationOptions: UseMutationOptions<
    InviteUserResponse,
    InviteUserError,
    Options<InviteUserData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await inviteUser({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const resendUserInviteQueryKey = (
  options: Options<ResendUserInviteData>,
) => createQueryKey("resendUserInvite", options);

export const resendUserInviteOptions = (
  options: Options<ResendUserInviteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await resendUserInvite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: resendUserInviteQueryKey(options),
  });
};

export const resendUserInviteMutation = (
  options?: Partial<Options<ResendUserInviteData>>,
): UseMutationOptions<
  ResendUserInviteResponse,
  ResendUserInviteError,
  Options<ResendUserInviteData>
> => {
  const mutationOptions: UseMutationOptions<
    ResendUserInviteResponse,
    ResendUserInviteError,
    Options<ResendUserInviteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await resendUserInvite({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listIdentitiesQueryKey = (options?: Options<ListIdentitiesData>) =>
  createQueryKey("listIdentities", options);

export const listIdentitiesOptions = (
  options?: Options<ListIdentitiesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listIdentities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listIdentitiesQueryKey(options),
  });
};

export const setIdentityReadOnlyMutation = (
  options?: Partial<Options<SetIdentityReadOnlyData>>,
): UseMutationOptions<
  SetIdentityReadOnlyResponse,
  SetIdentityReadOnlyError,
  Options<SetIdentityReadOnlyData>
> => {
  const mutationOptions: UseMutationOptions<
    SetIdentityReadOnlyResponse,
    SetIdentityReadOnlyError,
    Options<SetIdentityReadOnlyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await setIdentityReadOnly({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteIdentityMutation = (
  options?: Partial<Options<DeleteIdentityData>>,
): UseMutationOptions<
  DeleteIdentityResponse,
  DeleteIdentityError,
  Options<DeleteIdentityData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteIdentityResponse,
    DeleteIdentityError,
    Options<DeleteIdentityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteIdentity({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const clientAuthenticatedQueryKey = (
  options?: Options<ClientAuthenticatedData>,
) => createQueryKey("clientAuthenticated", options);

export const clientAuthenticatedOptions = (
  options?: Options<ClientAuthenticatedData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientAuthenticated({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: clientAuthenticatedQueryKey(options),
  });
};

export const clientLoginQueryKey = (options?: Options<ClientLoginData>) =>
  createQueryKey("clientLogin", options);

export const clientLoginOptions = (options?: Options<ClientLoginData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientLogin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: clientLoginQueryKey(options),
  });
};

export const clientLoginMutation = (
  options?: Partial<Options<ClientLoginData>>,
): UseMutationOptions<
  ClientLoginResponse,
  ClientLoginError,
  Options<ClientLoginData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientLoginResponse,
    ClientLoginError,
    Options<ClientLoginData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientLogin({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const completeUserRegistrationQueryKey = (
  options: Options<CompleteUserRegistrationData>,
) => createQueryKey("completeUserRegistration", options);

export const completeUserRegistrationOptions = (
  options: Options<CompleteUserRegistrationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await completeUserRegistration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: completeUserRegistrationQueryKey(options),
  });
};

export const completeUserRegistrationMutation = (
  options?: Partial<Options<CompleteUserRegistrationData>>,
): UseMutationOptions<
  CompleteUserRegistrationResponse,
  CompleteUserRegistrationError,
  Options<CompleteUserRegistrationData>
> => {
  const mutationOptions: UseMutationOptions<
    CompleteUserRegistrationResponse,
    CompleteUserRegistrationError,
    Options<CompleteUserRegistrationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await completeUserRegistration({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const adminLoginAsPartnerQueryKey = (
  options?: Options<AdminLoginAsPartnerData>,
) => createQueryKey("adminLoginAsPartner", options);

export const adminLoginAsPartnerOptions = (
  options?: Options<AdminLoginAsPartnerData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await adminLoginAsPartner({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: adminLoginAsPartnerQueryKey(options),
  });
};

export const adminLoginAsPartnerMutation = (
  options?: Partial<Options<AdminLoginAsPartnerData>>,
): UseMutationOptions<
  AdminLoginAsPartnerResponse,
  DefaultError,
  Options<AdminLoginAsPartnerData>
> => {
  const mutationOptions: UseMutationOptions<
    AdminLoginAsPartnerResponse,
    DefaultError,
    Options<AdminLoginAsPartnerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await adminLoginAsPartner({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const adminLoginAsDriverQueryKey = (
  options?: Options<AdminLoginAsDriverData>,
) => createQueryKey("adminLoginAsDriver", options);

export const adminLoginAsDriverOptions = (
  options?: Options<AdminLoginAsDriverData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await adminLoginAsDriver({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: adminLoginAsDriverQueryKey(options),
  });
};

export const adminLoginAsDriverMutation = (
  options?: Partial<Options<AdminLoginAsDriverData>>,
): UseMutationOptions<
  AdminLoginAsDriverResponse,
  DefaultError,
  Options<AdminLoginAsDriverData>
> => {
  const mutationOptions: UseMutationOptions<
    AdminLoginAsDriverResponse,
    DefaultError,
    Options<AdminLoginAsDriverData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await adminLoginAsDriver({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const registerSiteOwnerQueryKey = (
  options: Options<RegisterSiteOwnerData>,
) => createQueryKey("registerSiteOwner", options);

export const registerSiteOwnerOptions = (
  options: Options<RegisterSiteOwnerData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await registerSiteOwner({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: registerSiteOwnerQueryKey(options),
  });
};

export const registerSiteOwnerMutation = (
  options?: Partial<Options<RegisterSiteOwnerData>>,
): UseMutationOptions<
  RegisterSiteOwnerResponse,
  RegisterSiteOwnerError,
  Options<RegisterSiteOwnerData>
> => {
  const mutationOptions: UseMutationOptions<
    RegisterSiteOwnerResponse,
    RegisterSiteOwnerError,
    Options<RegisterSiteOwnerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await registerSiteOwner({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getJwksQueryKey = (options?: Options<GetJwksData>) =>
  createQueryKey("getJwks", options);

export const getJwksOptions = (options?: Options<GetJwksData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJwks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJwksQueryKey(options),
  });
};

export const getOpenidConfigurationQueryKey = (
  options?: Options<GetOpenidConfigurationData>,
) => createQueryKey("getOpenidConfiguration", options);

export const getOpenidConfigurationOptions = (
  options?: Options<GetOpenidConfigurationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOpenidConfiguration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOpenidConfigurationQueryKey(options),
  });
};

export const listControllerTokensQueryKey = (
  options?: Options<ListControllerTokensData>,
) => createQueryKey("listControllerTokens", options);

export const listControllerTokensOptions = (
  options?: Options<ListControllerTokensData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listControllerTokens({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listControllerTokensQueryKey(options),
  });
};

export const createControllerTokenAsAdminQueryKey = (
  options: Options<CreateControllerTokenAsAdminData>,
) => createQueryKey("createControllerTokenAsAdmin", options);

export const createControllerTokenAsAdminOptions = (
  options: Options<CreateControllerTokenAsAdminData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createControllerTokenAsAdmin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createControllerTokenAsAdminQueryKey(options),
  });
};

export const createControllerTokenAsAdminMutation = (
  options?: Partial<Options<CreateControllerTokenAsAdminData>>,
): UseMutationOptions<
  CreateControllerTokenAsAdminResponse,
  CreateControllerTokenAsAdminError,
  Options<CreateControllerTokenAsAdminData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateControllerTokenAsAdminResponse,
    CreateControllerTokenAsAdminError,
    Options<CreateControllerTokenAsAdminData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createControllerTokenAsAdmin({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const revokeControllerTokenMutation = (
  options?: Partial<Options<RevokeControllerTokenData>>,
): UseMutationOptions<
  RevokeControllerTokenResponse,
  RevokeControllerTokenError,
  Options<RevokeControllerTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokeControllerTokenResponse,
    RevokeControllerTokenError,
    Options<RevokeControllerTokenData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await revokeControllerToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const createControllerImagePullTokenQueryKey = (
  options?: Options<CreateControllerImagePullTokenData>,
) => createQueryKey("createControllerImagePullToken", options);

export const createControllerImagePullTokenOptions = (
  options?: Options<CreateControllerImagePullTokenData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createControllerImagePullToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createControllerImagePullTokenQueryKey(options),
  });
};

export const createControllerImagePullTokenMutation = (
  options?: Partial<Options<CreateControllerImagePullTokenData>>,
): UseMutationOptions<
  CreateControllerImagePullTokenResponse,
  DefaultError,
  Options<CreateControllerImagePullTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateControllerImagePullTokenResponse,
    DefaultError,
    Options<CreateControllerImagePullTokenData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createControllerImagePullToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getControllerConfigurationQueryKey = (
  options?: Options<GetControllerConfigurationData>,
) => createQueryKey("getControllerConfiguration", options);

export const getControllerConfigurationOptions = (
  options?: Options<GetControllerConfigurationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControllerConfiguration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getControllerConfigurationQueryKey(options),
  });
};

export const schemaOnlyControllerAdminQueryKey = (
  options?: Options<SchemaOnlyControllerAdminData>,
) => createQueryKey("schemaOnlyControllerAdmin", options);

export const schemaOnlyControllerAdminOptions = (
  options?: Options<SchemaOnlyControllerAdminData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schemaOnlyControllerAdmin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: schemaOnlyControllerAdminQueryKey(options),
  });
};

export const schemaOnlyControllerAdminMutation = (
  options?: Partial<Options<SchemaOnlyControllerAdminData>>,
): UseMutationOptions<
  SchemaOnlyControllerAdminResponse,
  DefaultError,
  Options<SchemaOnlyControllerAdminData>
> => {
  const mutationOptions: UseMutationOptions<
    SchemaOnlyControllerAdminResponse,
    DefaultError,
    Options<SchemaOnlyControllerAdminData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await schemaOnlyControllerAdmin({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const schemaOnlyDeviceInfoQueryKey = (
  options: Options<SchemaOnlyDeviceInfoData>,
) => createQueryKey("schemaOnlyDeviceInfo", options);

export const schemaOnlyDeviceInfoOptions = (
  options: Options<SchemaOnlyDeviceInfoData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schemaOnlyDeviceInfo({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: schemaOnlyDeviceInfoQueryKey(options),
  });
};

export const schemaOnlyDeviceInfoMutation = (
  options?: Partial<Options<SchemaOnlyDeviceInfoData>>,
): UseMutationOptions<
  unknown,
  SchemaOnlyDeviceInfoError,
  Options<SchemaOnlyDeviceInfoData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SchemaOnlyDeviceInfoError,
    Options<SchemaOnlyDeviceInfoData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await schemaOnlyDeviceInfo({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const reportControllerAlertsQueryKey = (
  options: Options<ReportControllerAlertsData>,
) => createQueryKey("reportControllerAlerts", options);

export const reportControllerAlertsOptions = (
  options: Options<ReportControllerAlertsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportControllerAlerts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: reportControllerAlertsQueryKey(options),
  });
};

export const reportControllerAlertsMutation = (
  options?: Partial<Options<ReportControllerAlertsData>>,
): UseMutationOptions<
  ReportControllerAlertsResponse,
  ReportControllerAlertsError,
  Options<ReportControllerAlertsData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportControllerAlertsResponse,
    ReportControllerAlertsError,
    Options<ReportControllerAlertsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportControllerAlerts({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listSiteAlertsQueryKey = (options: Options<ListSiteAlertsData>) =>
  createQueryKey("listSiteAlerts", options);

export const listSiteAlertsOptions = (options: Options<ListSiteAlertsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSiteAlerts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSiteAlertsQueryKey(options),
  });
};

export const listSiteAlertsInfiniteQueryKey = (
  options: Options<ListSiteAlertsData>,
): QueryKey<Options<ListSiteAlertsData>> =>
  createQueryKey("listSiteAlerts", options, true);

export const listSiteAlertsInfiniteOptions = (
  options: Options<ListSiteAlertsData>,
) => {
  return infiniteQueryOptions<
    ListSiteAlertsResponse,
    ListSiteAlertsError,
    InfiniteData<ListSiteAlertsResponse>,
    QueryKey<Options<ListSiteAlertsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListSiteAlertsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListSiteAlertsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listSiteAlerts({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listSiteAlertsInfiniteQueryKey(options),
    },
  );
};

export const getSiteAlertSettingsQueryKey = (
  options: Options<GetSiteAlertSettingsData>,
) => createQueryKey("getSiteAlertSettings", options);

export const getSiteAlertSettingsOptions = (
  options: Options<GetSiteAlertSettingsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSiteAlertSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSiteAlertSettingsQueryKey(options),
  });
};

export const updateSiteAlertSettingsMutation = (
  options?: Partial<Options<UpdateSiteAlertSettingsData>>,
): UseMutationOptions<
  UpdateSiteAlertSettingsResponse,
  UpdateSiteAlertSettingsError,
  Options<UpdateSiteAlertSettingsData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateSiteAlertSettingsResponse,
    UpdateSiteAlertSettingsError,
    Options<UpdateSiteAlertSettingsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateSiteAlertSettings({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listSiteIoConfigurationsQueryKey = (
  options?: Options<ListSiteIoConfigurationsData>,
) => createQueryKey("listSiteIoConfigurations", options);

export const listSiteIoConfigurationsOptions = (
  options?: Options<ListSiteIoConfigurationsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSiteIoConfigurations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSiteIoConfigurationsQueryKey(options),
  });
};

export const getSiteIoConfigurationQueryKey = (
  options: Options<GetSiteIoConfigurationData>,
) => createQueryKey("getSiteIoConfiguration", options);

export const getSiteIoConfigurationOptions = (
  options: Options<GetSiteIoConfigurationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSiteIoConfiguration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSiteIoConfigurationQueryKey(options),
  });
};

export const patchSiteIoConfigurationMutation = (
  options?: Partial<Options<PatchSiteIoConfigurationData>>,
): UseMutationOptions<
  PatchSiteIoConfigurationResponse,
  PatchSiteIoConfigurationError,
  Options<PatchSiteIoConfigurationData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchSiteIoConfigurationResponse,
    PatchSiteIoConfigurationError,
    Options<PatchSiteIoConfigurationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await patchSiteIoConfiguration({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const createSiteIoConfigurationQueryKey = (
  options: Options<CreateSiteIoConfigurationData>,
) => createQueryKey("createSiteIoConfiguration", options);

export const createSiteIoConfigurationOptions = (
  options: Options<CreateSiteIoConfigurationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createSiteIoConfiguration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createSiteIoConfigurationQueryKey(options),
  });
};

export const createSiteIoConfigurationMutation = (
  options?: Partial<Options<CreateSiteIoConfigurationData>>,
): UseMutationOptions<
  CreateSiteIoConfigurationResponse,
  CreateSiteIoConfigurationError,
  Options<CreateSiteIoConfigurationData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSiteIoConfigurationResponse,
    CreateSiteIoConfigurationError,
    Options<CreateSiteIoConfigurationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createSiteIoConfiguration({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getControllerConfigurationStatusQueryKey = (
  options: Options<GetControllerConfigurationStatusData>,
) => createQueryKey("getControllerConfigurationStatus", options);

export const getControllerConfigurationStatusOptions = (
  options: Options<GetControllerConfigurationStatusData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControllerConfigurationStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getControllerConfigurationStatusQueryKey(options),
  });
};

export const getModbusRegisterCatalogQueryKey = (
  options?: Options<GetModbusRegisterCatalogData>,
) => createQueryKey("getModbusRegisterCatalog", options);

export const getModbusRegisterCatalogOptions = (
  options?: Options<GetModbusRegisterCatalogData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getModbusRegisterCatalog({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getModbusRegisterCatalogQueryKey(options),
  });
};

export const getPartnersQueryKey = (options?: Options<GetPartnersData>) =>
  createQueryKey("getPartners", options);

export const getPartnersOptions = (options?: Options<GetPartnersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPartners({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPartnersQueryKey(options),
  });
};

export const createPartnerQueryKey = (options: Options<CreatePartnerData>) =>
  createQueryKey("createPartner", options);

export const createPartnerOptions = (options: Options<CreatePartnerData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createPartner({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createPartnerQueryKey(options),
  });
};

export const createPartnerMutation = (
  options?: Partial<Options<CreatePartnerData>>,
): UseMutationOptions<
  CreatePartnerResponse,
  CreatePartnerError,
  Options<CreatePartnerData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePartnerResponse,
    CreatePartnerError,
    Options<CreatePartnerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createPartner({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const partnerRouterDeletePartnerV1PartnerPartnerIdDeleteMutation = (
  options?: Partial<
    Options<PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteData>
  >,
): UseMutationOptions<
  unknown,
  PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteError,
  Options<PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteError,
    Options<PartnerRouterDeletePartnerV1PartnerPartnerIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await partnerRouterDeletePartnerV1PartnerPartnerIdDelete(
        {
          ...options,
          ...localOptions,
          throwOnError: true,
        },
      );
      return data;
    },
  };
  return mutationOptions;
};

export const partnerRouterGetPartnerV1PartnerPartnerIdGetQueryKey = (
  options: Options<PartnerRouterGetPartnerV1PartnerPartnerIdGetData>,
) => createQueryKey("partnerRouterGetPartnerV1PartnerPartnerIdGet", options);

export const partnerRouterGetPartnerV1PartnerPartnerIdGetOptions = (
  options: Options<PartnerRouterGetPartnerV1PartnerPartnerIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await partnerRouterGetPartnerV1PartnerPartnerIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: partnerRouterGetPartnerV1PartnerPartnerIdGetQueryKey(options),
  });
};

export const partnerRouterUpdatePartnerV1PartnerPartnerIdPutMutation = (
  options?: Partial<
    Options<PartnerRouterUpdatePartnerV1PartnerPartnerIdPutData>
  >,
): UseMutationOptions<
  PartnerRouterUpdatePartnerV1PartnerPartnerIdPutResponse,
  PartnerRouterUpdatePartnerV1PartnerPartnerIdPutError,
  Options<PartnerRouterUpdatePartnerV1PartnerPartnerIdPutData>
> => {
  const mutationOptions: UseMutationOptions<
    PartnerRouterUpdatePartnerV1PartnerPartnerIdPutResponse,
    PartnerRouterUpdatePartnerV1PartnerPartnerIdPutError,
    Options<PartnerRouterUpdatePartnerV1PartnerPartnerIdPutData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await partnerRouterUpdatePartnerV1PartnerPartnerIdPut({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const partnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostQueryKey =
  (
    options: Options<PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostData>,
  ) =>
    createQueryKey(
      "partnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPost",
      options,
    );

export const partnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostOptions =
  (
    options: Options<PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await partnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPost(
            {
              ...options,
              ...queryKey[0],
              signal,
              throwOnError: true,
            },
          );
        return data;
      },
      queryKey:
        partnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostQueryKey(
          options,
        ),
    });
  };

export const partnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostMutation =
  (
    options?: Partial<
      Options<PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostData>
    >,
  ): UseMutationOptions<
    PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostResponse,
    PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostError,
    Options<PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostResponse,
      PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostError,
      Options<PartnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPostData>
    > = {
      mutationFn: async (localOptions) => {
        const { data } =
          await partnerRouterAddPartnerConnectionV1PartnerPartnerIdConnectionPost(
            {
              ...options,
              ...localOptions,
              throwOnError: true,
            },
          );
        return data;
      },
    };
    return mutationOptions;
  };

export const getPartnerBrandingQueryKey = (
  options: Options<GetPartnerBrandingData>,
) => createQueryKey("getPartnerBranding", options);

export const getPartnerBrandingOptions = (
  options: Options<GetPartnerBrandingData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPartnerBranding({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPartnerBrandingQueryKey(options),
  });
};

export const getAggregatedScheduleQueryKey = (
  options: Options<GetAggregatedScheduleData>,
) => createQueryKey("getAggregatedSchedule", options);

export const getAggregatedScheduleOptions = (
  options: Options<GetAggregatedScheduleData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAggregatedSchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAggregatedScheduleQueryKey(options),
  });
};

export const getAggregatedScheduleInfiniteQueryKey = (
  options: Options<GetAggregatedScheduleData>,
): QueryKey<Options<GetAggregatedScheduleData>> =>
  createQueryKey("getAggregatedSchedule", options, true);

export const getAggregatedScheduleInfiniteOptions = (
  options: Options<GetAggregatedScheduleData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetAggregatedScheduleError,
    InfiniteData<unknown>,
    QueryKey<Options<GetAggregatedScheduleData>>,
    | string
    | Pick<
        QueryKey<Options<GetAggregatedScheduleData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetAggregatedScheduleData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getAggregatedSchedule({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getAggregatedScheduleInfiniteQueryKey(options),
    },
  );
};

export const getAggregatedSocScheduleQueryKey = (
  options: Options<GetAggregatedSocScheduleData>,
) => createQueryKey("getAggregatedSocSchedule", options);

export const getAggregatedSocScheduleOptions = (
  options: Options<GetAggregatedSocScheduleData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAggregatedSocSchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAggregatedSocScheduleQueryKey(options),
  });
};

export const getAggregatedSocScheduleInfiniteQueryKey = (
  options: Options<GetAggregatedSocScheduleData>,
): QueryKey<Options<GetAggregatedSocScheduleData>> =>
  createQueryKey("getAggregatedSocSchedule", options, true);

export const getAggregatedSocScheduleInfiniteOptions = (
  options: Options<GetAggregatedSocScheduleData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetAggregatedSocScheduleError,
    InfiniteData<unknown>,
    QueryKey<Options<GetAggregatedSocScheduleData>>,
    | string
    | Pick<
        QueryKey<Options<GetAggregatedSocScheduleData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetAggregatedSocScheduleData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getAggregatedSocSchedule({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getAggregatedSocScheduleInfiniteQueryKey(options),
    },
  );
};

export const getEnergyScheduleQueryKey = (
  options: Options<GetEnergyScheduleData>,
) => createQueryKey("getEnergySchedule", options);

export const getEnergyScheduleOptions = (
  options: Options<GetEnergyScheduleData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEnergySchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEnergyScheduleQueryKey(options),
  });
};

export const getAssetEnergyScheduleQueryKey = (
  options: Options<GetAssetEnergyScheduleData>,
) => createQueryKey("getAssetEnergySchedule", options);

export const getAssetEnergyScheduleOptions = (
  options: Options<GetAssetEnergyScheduleData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssetEnergySchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAssetEnergyScheduleQueryKey(options),
  });
};

export const getOptimizationResultQueryKey = (
  options: Options<GetOptimizationResultData>,
) => createQueryKey("getOptimizationResult", options);

export const getOptimizationResultOptions = (
  options: Options<GetOptimizationResultData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOptimizationResult({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOptimizationResultQueryKey(options),
  });
};

export const schemaOnlyAdviceQueryKey = (
  options: Options<SchemaOnlyAdviceData>,
) => createQueryKey("schemaOnlyAdvice", options);

export const schemaOnlyAdviceOptions = (
  options: Options<SchemaOnlyAdviceData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schemaOnlyAdvice({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: schemaOnlyAdviceQueryKey(options),
  });
};

export const schemaOnlyAdviceMutation = (
  options?: Partial<Options<SchemaOnlyAdviceData>>,
): UseMutationOptions<
  SchemaOnlyAdviceResponse,
  SchemaOnlyAdviceError,
  Options<SchemaOnlyAdviceData>
> => {
  const mutationOptions: UseMutationOptions<
    SchemaOnlyAdviceResponse,
    SchemaOnlyAdviceError,
    Options<SchemaOnlyAdviceData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await schemaOnlyAdvice({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const schemaOnlyPoliciesQueryKey = (
  options?: Options<SchemaOnlyPoliciesData>,
) => createQueryKey("schemaOnlyPolicies", options);

export const schemaOnlyPoliciesOptions = (
  options?: Options<SchemaOnlyPoliciesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schemaOnlyPolicies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: schemaOnlyPoliciesQueryKey(options),
  });
};

export const getDayAHeadPricesQueryKey = (
  options: Options<GetDayAHeadPricesData>,
) => createQueryKey("getDayAHeadPrices", options);

export const getDayAHeadPricesOptions = (
  options: Options<GetDayAHeadPricesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDayAHeadPrices({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDayAHeadPricesQueryKey(options),
  });
};

export const getDayAHeadPricesWithForecastQueryKey = (
  options: Options<GetDayAHeadPricesWithForecastData>,
) => createQueryKey("getDayAHeadPricesWithForecast", options);

export const getDayAHeadPricesWithForecastOptions = (
  options: Options<GetDayAHeadPricesWithForecastData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDayAHeadPricesWithForecast({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDayAHeadPricesWithForecastQueryKey(options),
  });
};

export const optimizationsGetTasksQueryKey = (
  options: Options<OptimizationsGetTasksData>,
) => createQueryKey("optimizationsGetTasks", options);

export const optimizationsGetTasksOptions = (
  options: Options<OptimizationsGetTasksData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await optimizationsGetTasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: optimizationsGetTasksQueryKey(options),
  });
};

export const optimizationsGetTasksInfiniteQueryKey = (
  options: Options<OptimizationsGetTasksData>,
): QueryKey<Options<OptimizationsGetTasksData>> =>
  createQueryKey("optimizationsGetTasks", options, true);

export const optimizationsGetTasksInfiniteOptions = (
  options: Options<OptimizationsGetTasksData>,
) => {
  return infiniteQueryOptions<
    OptimizationsGetTasksResponse,
    OptimizationsGetTasksError,
    InfiniteData<OptimizationsGetTasksResponse>,
    QueryKey<Options<OptimizationsGetTasksData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<OptimizationsGetTasksData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OptimizationsGetTasksData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await optimizationsGetTasks({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: optimizationsGetTasksInfiniteQueryKey(options),
    },
  );
};

export const optimizationsDeleteTaskMutation = (
  options?: Partial<Options<OptimizationsDeleteTaskData>>,
): UseMutationOptions<
  unknown,
  OptimizationsDeleteTaskError,
  Options<OptimizationsDeleteTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    OptimizationsDeleteTaskError,
    Options<OptimizationsDeleteTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await optimizationsDeleteTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const optimizationsGetTaskQueryKey = (
  options: Options<OptimizationsGetTaskData>,
) => createQueryKey("optimizationsGetTask", options);

export const optimizationsGetTaskOptions = (
  options: Options<OptimizationsGetTaskData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await optimizationsGetTask({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: optimizationsGetTaskQueryKey(options),
  });
};

export const optimizationsCreateTaskQueryKey = (
  options: Options<OptimizationsCreateTaskData>,
) => createQueryKey("optimizationsCreateTask", options);

export const optimizationsCreateTaskOptions = (
  options: Options<OptimizationsCreateTaskData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await optimizationsCreateTask({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: optimizationsCreateTaskQueryKey(options),
  });
};

export const optimizationsCreateTaskMutation = (
  options?: Partial<Options<OptimizationsCreateTaskData>>,
): UseMutationOptions<
  OptimizationsCreateTaskResponse,
  OptimizationsCreateTaskError,
  Options<OptimizationsCreateTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    OptimizationsCreateTaskResponse,
    OptimizationsCreateTaskError,
    Options<OptimizationsCreateTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await optimizationsCreateTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const optimizationsUpdateTaskMutation = (
  options?: Partial<Options<OptimizationsUpdateTaskData>>,
): UseMutationOptions<
  OptimizationsUpdateTaskResponse,
  OptimizationsUpdateTaskError,
  Options<OptimizationsUpdateTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    OptimizationsUpdateTaskResponse,
    OptimizationsUpdateTaskError,
    Options<OptimizationsUpdateTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await optimizationsUpdateTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const predictionsGetTasksQueryKey = (
  options: Options<PredictionsGetTasksData>,
) => createQueryKey("predictionsGetTasks", options);

export const predictionsGetTasksOptions = (
  options: Options<PredictionsGetTasksData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await predictionsGetTasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: predictionsGetTasksQueryKey(options),
  });
};

export const predictionsGetTasksInfiniteQueryKey = (
  options: Options<PredictionsGetTasksData>,
): QueryKey<Options<PredictionsGetTasksData>> =>
  createQueryKey("predictionsGetTasks", options, true);

export const predictionsGetTasksInfiniteOptions = (
  options: Options<PredictionsGetTasksData>,
) => {
  return infiniteQueryOptions<
    PredictionsGetTasksResponse,
    PredictionsGetTasksError,
    InfiniteData<PredictionsGetTasksResponse>,
    QueryKey<Options<PredictionsGetTasksData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<PredictionsGetTasksData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<PredictionsGetTasksData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await predictionsGetTasks({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: predictionsGetTasksInfiniteQueryKey(options),
    },
  );
};

export const predictionsDeleteTaskMutation = (
  options?: Partial<Options<PredictionsDeleteTaskData>>,
): UseMutationOptions<
  unknown,
  PredictionsDeleteTaskError,
  Options<PredictionsDeleteTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    PredictionsDeleteTaskError,
    Options<PredictionsDeleteTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await predictionsDeleteTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const predictionsGetTaskQueryKey = (
  options: Options<PredictionsGetTaskData>,
) => createQueryKey("predictionsGetTask", options);

export const predictionsGetTaskOptions = (
  options: Options<PredictionsGetTaskData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await predictionsGetTask({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: predictionsGetTaskQueryKey(options),
  });
};

export const predictionsCreateTaskQueryKey = (
  options: Options<PredictionsCreateTaskData>,
) => createQueryKey("predictionsCreateTask", options);

export const predictionsCreateTaskOptions = (
  options: Options<PredictionsCreateTaskData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await predictionsCreateTask({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: predictionsCreateTaskQueryKey(options),
  });
};

export const predictionsCreateTaskMutation = (
  options?: Partial<Options<PredictionsCreateTaskData>>,
): UseMutationOptions<
  PredictionsCreateTaskResponse,
  PredictionsCreateTaskError,
  Options<PredictionsCreateTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    PredictionsCreateTaskResponse,
    PredictionsCreateTaskError,
    Options<PredictionsCreateTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await predictionsCreateTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const predictionsUpdateTaskMutation = (
  options?: Partial<Options<PredictionsUpdateTaskData>>,
): UseMutationOptions<
  PredictionsUpdateTaskResponse,
  PredictionsUpdateTaskError,
  Options<PredictionsUpdateTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    PredictionsUpdateTaskResponse,
    PredictionsUpdateTaskError,
    Options<PredictionsUpdateTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await predictionsUpdateTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const forecastingGetTasksQueryKey = (
  options: Options<ForecastingGetTasksData>,
) => createQueryKey("forecastingGetTasks", options);

export const forecastingGetTasksOptions = (
  options: Options<ForecastingGetTasksData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await forecastingGetTasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: forecastingGetTasksQueryKey(options),
  });
};

export const forecastingGetTasksInfiniteQueryKey = (
  options: Options<ForecastingGetTasksData>,
): QueryKey<Options<ForecastingGetTasksData>> =>
  createQueryKey("forecastingGetTasks", options, true);

export const forecastingGetTasksInfiniteOptions = (
  options: Options<ForecastingGetTasksData>,
) => {
  return infiniteQueryOptions<
    ForecastingGetTasksResponse,
    ForecastingGetTasksError,
    InfiniteData<ForecastingGetTasksResponse>,
    QueryKey<Options<ForecastingGetTasksData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ForecastingGetTasksData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ForecastingGetTasksData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await forecastingGetTasks({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: forecastingGetTasksInfiniteQueryKey(options),
    },
  );
};

export const forecastingDeleteTaskMutation = (
  options?: Partial<Options<ForecastingDeleteTaskData>>,
): UseMutationOptions<
  unknown,
  ForecastingDeleteTaskError,
  Options<ForecastingDeleteTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ForecastingDeleteTaskError,
    Options<ForecastingDeleteTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await forecastingDeleteTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const forecastingGetTaskQueryKey = (
  options: Options<ForecastingGetTaskData>,
) => createQueryKey("forecastingGetTask", options);

export const forecastingGetTaskOptions = (
  options: Options<ForecastingGetTaskData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await forecastingGetTask({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: forecastingGetTaskQueryKey(options),
  });
};

export const forecastingCreateTaskQueryKey = (
  options: Options<ForecastingCreateTaskData>,
) => createQueryKey("forecastingCreateTask", options);

export const forecastingCreateTaskOptions = (
  options: Options<ForecastingCreateTaskData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await forecastingCreateTask({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: forecastingCreateTaskQueryKey(options),
  });
};

export const forecastingCreateTaskMutation = (
  options?: Partial<Options<ForecastingCreateTaskData>>,
): UseMutationOptions<
  ForecastingCreateTaskResponse,
  ForecastingCreateTaskError,
  Options<ForecastingCreateTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    ForecastingCreateTaskResponse,
    ForecastingCreateTaskError,
    Options<ForecastingCreateTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await forecastingCreateTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const forecastingUpdateTaskMutation = (
  options?: Partial<Options<ForecastingUpdateTaskData>>,
): UseMutationOptions<
  ForecastingUpdateTaskResponse,
  ForecastingUpdateTaskError,
  Options<ForecastingUpdateTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    ForecastingUpdateTaskResponse,
    ForecastingUpdateTaskError,
    Options<ForecastingUpdateTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await forecastingUpdateTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSiteForecastsQueryKey = (
  options: Options<GetSiteForecastsData>,
) => createQueryKey("getSiteForecasts", options);

export const getSiteForecastsOptions = (
  options: Options<GetSiteForecastsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSiteForecasts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSiteForecastsQueryKey(options),
  });
};

export const getSiteForecastsInfiniteQueryKey = (
  options: Options<GetSiteForecastsData>,
): QueryKey<Options<GetSiteForecastsData>> =>
  createQueryKey("getSiteForecasts", options, true);

export const getSiteForecastsInfiniteOptions = (
  options: Options<GetSiteForecastsData>,
) => {
  return infiniteQueryOptions<
    GetSiteForecastsResponse,
    GetSiteForecastsError,
    InfiniteData<GetSiteForecastsResponse>,
    QueryKey<Options<GetSiteForecastsData>>,
    | string
    | Pick<
        QueryKey<Options<GetSiteForecastsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetSiteForecastsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getSiteForecasts({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getSiteForecastsInfiniteQueryKey(options),
    },
  );
};

export const getDevicePredictionInsightsInArrowQueryKey = (
  options: Options<GetDevicePredictionInsightsInArrowData>,
) => createQueryKey("getDevicePredictionInsightsInArrow", options);

export const getDevicePredictionInsightsInArrowOptions = (
  options: Options<GetDevicePredictionInsightsInArrowData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDevicePredictionInsightsInArrow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDevicePredictionInsightsInArrowQueryKey(options),
  });
};

export const getDevicePredictionInsightsInArrowInfiniteQueryKey = (
  options: Options<GetDevicePredictionInsightsInArrowData>,
): QueryKey<Options<GetDevicePredictionInsightsInArrowData>> =>
  createQueryKey("getDevicePredictionInsightsInArrow", options, true);

export const getDevicePredictionInsightsInArrowInfiniteOptions = (
  options: Options<GetDevicePredictionInsightsInArrowData>,
) => {
  return infiniteQueryOptions<
    unknown,
    GetDevicePredictionInsightsInArrowError,
    InfiniteData<unknown>,
    QueryKey<Options<GetDevicePredictionInsightsInArrowData>>,
    | string
    | Pick<
        QueryKey<Options<GetDevicePredictionInsightsInArrowData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetDevicePredictionInsightsInArrowData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getDevicePredictionInsightsInArrow({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getDevicePredictionInsightsInArrowInfiniteQueryKey(options),
    },
  );
};

export const getImbalancePriceInsightsQueryKey = (
  options: Options<GetImbalancePriceInsightsData>,
) => createQueryKey("getImbalancePriceInsights", options);

export const getImbalancePriceInsightsOptions = (
  options: Options<GetImbalancePriceInsightsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImbalancePriceInsights({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImbalancePriceInsightsQueryKey(options),
  });
};

export const getImbalanceForecastMetricsQueryKey = (
  options: Options<GetImbalanceForecastMetricsData>,
) => createQueryKey("getImbalanceForecastMetrics", options);

export const getImbalanceForecastMetricsOptions = (
  options: Options<GetImbalanceForecastMetricsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImbalanceForecastMetrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImbalanceForecastMetricsQueryKey(options),
  });
};

export const getImbalancePriceInsightsInfiniteQueryKey = (
  options: Options<GetImbalancePriceInsightsData>,
): QueryKey<Options<GetImbalancePriceInsightsData>> =>
  createQueryKey("getImbalancePriceInsights", options, true);

export const getImbalancePriceInsightsInfiniteOptions = (
  options: Options<GetImbalancePriceInsightsData>,
) => {
  return infiniteQueryOptions<
    GetImbalancePriceInsightsResponse,
    GetImbalancePriceInsightsError,
    InfiniteData<GetImbalancePriceInsightsResponse>,
    QueryKey<Options<GetImbalancePriceInsightsData>>,
    | string
    | Pick<
        QueryKey<Options<GetImbalancePriceInsightsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetImbalancePriceInsightsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getImbalancePriceInsights({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getImbalancePriceInsightsInfiniteQueryKey(options),
    },
  );
};

export const createForecastingTaskQueryKey = (
  options: Options<CreateForecastingTaskData>,
) => createQueryKey("createForecastingTask", options);

export const createForecastingTaskOptions = (
  options: Options<CreateForecastingTaskData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createForecastingTask({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createForecastingTaskQueryKey(options),
  });
};

export const createForecastingTaskMutation = (
  options?: Partial<Options<CreateForecastingTaskData>>,
): UseMutationOptions<
  unknown,
  CreateForecastingTaskError,
  Options<CreateForecastingTaskData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    CreateForecastingTaskError,
    Options<CreateForecastingTaskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createForecastingTask({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const forecastingGetGlobalTasksQueryKey = (
  options: Options<ForecastingGetGlobalTasksData>,
) => createQueryKey("forecastingGetGlobalTasks", options);

export const forecastingGetGlobalTasksOptions = (
  options: Options<ForecastingGetGlobalTasksData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await forecastingGetGlobalTasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: forecastingGetGlobalTasksQueryKey(options),
  });
};

export const forecastingGetGlobalTasksInfiniteQueryKey = (
  options: Options<ForecastingGetGlobalTasksData>,
): QueryKey<Options<ForecastingGetGlobalTasksData>> =>
  createQueryKey("forecastingGetGlobalTasks", options, true);

export const forecastingGetGlobalTasksInfiniteOptions = (
  options: Options<ForecastingGetGlobalTasksData>,
) => {
  return infiniteQueryOptions<
    ForecastingGetGlobalTasksResponse,
    ForecastingGetGlobalTasksError,
    InfiniteData<ForecastingGetGlobalTasksResponse>,
    QueryKey<Options<ForecastingGetGlobalTasksData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ForecastingGetGlobalTasksData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ForecastingGetGlobalTasksData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await forecastingGetGlobalTasks({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: forecastingGetGlobalTasksInfiniteQueryKey(options),
    },
  );
};

export const reschedulePendingForecastingTasksQueryKey = (
  options?: Options<ReschedulePendingForecastingTasksData>,
) => createQueryKey("reschedulePendingForecastingTasks", options);

export const reschedulePendingForecastingTasksOptions = (
  options?: Options<ReschedulePendingForecastingTasksData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reschedulePendingForecastingTasks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: reschedulePendingForecastingTasksQueryKey(options),
  });
};

export const reschedulePendingForecastingTasksMutation = (
  options?: Partial<Options<ReschedulePendingForecastingTasksData>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<ReschedulePendingForecastingTasksData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<ReschedulePendingForecastingTasksData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reschedulePendingForecastingTasks({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listProfilesQueryKey = (options: Options<ListProfilesData>) =>
  createQueryKey("listProfiles", options);

export const listProfilesOptions = (options: Options<ListProfilesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProfiles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listProfilesQueryKey(options),
  });
};

export const listProfilesInfiniteQueryKey = (
  options: Options<ListProfilesData>,
): QueryKey<Options<ListProfilesData>> =>
  createQueryKey("listProfiles", options, true);

export const listProfilesInfiniteOptions = (
  options: Options<ListProfilesData>,
) => {
  return infiniteQueryOptions<
    ListProfilesResponse,
    ListProfilesError,
    InfiniteData<ListProfilesResponse>,
    QueryKey<Options<ListProfilesData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListProfilesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListProfilesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listProfiles({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listProfilesInfiniteQueryKey(options),
    },
  );
};

export const createProfileQueryKey = (options: Options<CreateProfileData>) =>
  createQueryKey("createProfile", options);

export const createProfileOptions = (options: Options<CreateProfileData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createProfile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createProfileQueryKey(options),
  });
};

export const createProfileMutation = (
  options?: Partial<Options<CreateProfileData>>,
): UseMutationOptions<
  CreateProfileResponse,
  CreateProfileError,
  Options<CreateProfileData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateProfileResponse,
    CreateProfileError,
    Options<CreateProfileData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createProfile({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteProfileMutation = (
  options?: Partial<Options<DeleteProfileData>>,
): UseMutationOptions<
  DeleteProfileResponse,
  DeleteProfileError,
  Options<DeleteProfileData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteProfileResponse,
    DeleteProfileError,
    Options<DeleteProfileData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteProfile({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProfileQueryKey = (options: Options<GetProfileData>) =>
  createQueryKey("getProfile", options);

export const getProfileOptions = (options: Options<GetProfileData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProfile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProfileQueryKey(options),
  });
};

export const patchProfileMutation = (
  options?: Partial<Options<PatchProfileData>>,
): UseMutationOptions<
  PatchProfileResponse,
  PatchProfileError,
  Options<PatchProfileData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchProfileResponse,
    PatchProfileError,
    Options<PatchProfileData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await patchProfile({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const webhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostQueryKey =
  (
    options: Options<WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostData>,
  ) =>
    createQueryKey(
      "webhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPost",
      options,
    );

export const webhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostOptions =
  (
    options: Options<WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await webhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
          });
        return data;
      },
      queryKey:
        webhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostQueryKey(
          options,
        ),
    });
  };

export const webhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostMutation =
  (
    options?: Partial<
      Options<WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostData>
    >,
  ): UseMutationOptions<
    WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostResponse,
    WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostError,
    Options<WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostResponse,
      WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostError,
      Options<WebhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPostData>
    > = {
      mutationFn: async (localOptions) => {
        const { data } =
          await webhookRouterReceiveTeleportWebhookV1WithTheGridCallbackPost({
            ...options,
            ...localOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const loginWithPasswordQueryKey = (
  options: Options<LoginWithPasswordData>,
) => createQueryKey("loginWithPassword", options);

export const loginWithPasswordOptions = (
  options: Options<LoginWithPasswordData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await loginWithPassword({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: loginWithPasswordQueryKey(options),
  });
};

export const loginWithPasswordMutation = (
  options?: Partial<Options<LoginWithPasswordData>>,
): UseMutationOptions<
  LoginWithPasswordResponse,
  LoginWithPasswordError,
  Options<LoginWithPasswordData>
> => {
  const mutationOptions: UseMutationOptions<
    LoginWithPasswordResponse,
    LoginWithPasswordError,
    Options<LoginWithPasswordData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await loginWithPassword({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const startDriverLoginQueryKey = (
  options: Options<StartDriverLoginData>,
) => createQueryKey("startDriverLogin", options);

export const startDriverLoginOptions = (
  options: Options<StartDriverLoginData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await startDriverLogin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: startDriverLoginQueryKey(options),
  });
};

export const startDriverLoginMutation = (
  options?: Partial<Options<StartDriverLoginData>>,
): UseMutationOptions<
  StartDriverLoginResponse,
  StartDriverLoginError,
  Options<StartDriverLoginData>
> => {
  const mutationOptions: UseMutationOptions<
    StartDriverLoginResponse,
    StartDriverLoginError,
    Options<StartDriverLoginData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await startDriverLogin({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const requestPasswordResetQueryKey = (
  options: Options<RequestPasswordResetData>,
) => createQueryKey("requestPasswordReset", options);

export const requestPasswordResetOptions = (
  options: Options<RequestPasswordResetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await requestPasswordReset({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: requestPasswordResetQueryKey(options),
  });
};

export const requestPasswordResetMutation = (
  options?: Partial<Options<RequestPasswordResetData>>,
): UseMutationOptions<
  RequestPasswordResetResponse,
  RequestPasswordResetError,
  Options<RequestPasswordResetData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestPasswordResetResponse,
    RequestPasswordResetError,
    Options<RequestPasswordResetData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await requestPasswordReset({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const resetPasswordQueryKey = (options: Options<ResetPasswordData>) =>
  createQueryKey("resetPassword", options);

export const resetPasswordOptions = (options: Options<ResetPasswordData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await resetPassword({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: resetPasswordQueryKey(options),
  });
};

export const resetPasswordMutation = (
  options?: Partial<Options<ResetPasswordData>>,
): UseMutationOptions<
  ResetPasswordResponse,
  ResetPasswordError,
  Options<ResetPasswordData>
> => {
  const mutationOptions: UseMutationOptions<
    ResetPasswordResponse,
    ResetPasswordError,
    Options<ResetPasswordData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await resetPassword({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAuthenticatedDriverQueryKey = (
  options?: Options<GetAuthenticatedDriverData>,
) => createQueryKey("getAuthenticatedDriver", options);

export const getAuthenticatedDriverOptions = (
  options?: Options<GetAuthenticatedDriverData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAuthenticatedDriver({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAuthenticatedDriverQueryKey(options),
  });
};

export const batchCreateDriversQueryKey = (
  options: Options<BatchCreateDriversData>,
) => createQueryKey("batchCreateDrivers", options);

export const batchCreateDriversOptions = (
  options: Options<BatchCreateDriversData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await batchCreateDrivers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: batchCreateDriversQueryKey(options),
  });
};

export const batchCreateDriversMutation = (
  options?: Partial<Options<BatchCreateDriversData>>,
): UseMutationOptions<
  BatchCreateDriversResponse,
  BatchCreateDriversError,
  Options<BatchCreateDriversData>
> => {
  const mutationOptions: UseMutationOptions<
    BatchCreateDriversResponse,
    BatchCreateDriversError,
    Options<BatchCreateDriversData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await batchCreateDrivers({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDriversQueryKey = (options?: Options<GetDriversData>) =>
  createQueryKey("getDrivers", options);

export const getDriversOptions = (options?: Options<GetDriversData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDrivers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDriversQueryKey(options),
  });
};

export const createDriverQueryKey = (options: Options<CreateDriverData>) =>
  createQueryKey("createDriver", options);

export const createDriverOptions = (options: Options<CreateDriverData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createDriver({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createDriverQueryKey(options),
  });
};

export const createDriverMutation = (
  options?: Partial<Options<CreateDriverData>>,
): UseMutationOptions<
  CreateDriverResponse,
  CreateDriverError,
  Options<CreateDriverData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateDriverResponse,
    CreateDriverError,
    Options<CreateDriverData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createDriver({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setDriverProfileMutation = (
  options?: Partial<Options<SetDriverProfileData>>,
): UseMutationOptions<
  SetDriverProfileResponse,
  SetDriverProfileError,
  Options<SetDriverProfileData>
> => {
  const mutationOptions: UseMutationOptions<
    SetDriverProfileResponse,
    SetDriverProfileError,
    Options<SetDriverProfileData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await setDriverProfile({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setDriverCarMutation = (
  options?: Partial<Options<SetDriverCarData>>,
): UseMutationOptions<
  SetDriverCarResponse,
  SetDriverCarError,
  Options<SetDriverCarData>
> => {
  const mutationOptions: UseMutationOptions<
    SetDriverCarResponse,
    SetDriverCarError,
    Options<SetDriverCarData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await setDriverCar({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const markOnboardingAsSeenMutation = (
  options?: Partial<Options<MarkOnboardingAsSeenData>>,
): UseMutationOptions<
  MarkOnboardingAsSeenResponse,
  DefaultError,
  Options<MarkOnboardingAsSeenData>
> => {
  const mutationOptions: UseMutationOptions<
    MarkOnboardingAsSeenResponse,
    DefaultError,
    Options<MarkOnboardingAsSeenData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await markOnboardingAsSeen({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setDriverEmailMutation = (
  options?: Partial<Options<SetDriverEmailData>>,
): UseMutationOptions<
  SetDriverEmailResponse,
  SetDriverEmailError,
  Options<SetDriverEmailData>
> => {
  const mutationOptions: UseMutationOptions<
    SetDriverEmailResponse,
    SetDriverEmailError,
    Options<SetDriverEmailData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await setDriverEmail({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setDriverEmailNotificationsMutation = (
  options?: Partial<Options<SetDriverEmailNotificationsData>>,
): UseMutationOptions<
  SetDriverEmailNotificationsResponse,
  SetDriverEmailNotificationsError,
  Options<SetDriverEmailNotificationsData>
> => {
  const mutationOptions: UseMutationOptions<
    SetDriverEmailNotificationsResponse,
    SetDriverEmailNotificationsError,
    Options<SetDriverEmailNotificationsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await setDriverEmailNotifications({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setDriverPasswordMutation = (
  options?: Partial<Options<SetDriverPasswordData>>,
): UseMutationOptions<
  unknown,
  SetDriverPasswordError,
  Options<SetDriverPasswordData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SetDriverPasswordError,
    Options<SetDriverPasswordData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await setDriverPassword({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteDriverMutation = (
  options?: Partial<Options<DeleteDriverData>>,
): UseMutationOptions<
  unknown,
  DeleteDriverError,
  Options<DeleteDriverData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteDriverError,
    Options<DeleteDriverData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteDriver({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDriverQueryKey = (options: Options<GetDriverData>) =>
  createQueryKey("getDriver", options);

export const getDriverOptions = (options: Options<GetDriverData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriver({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDriverQueryKey(options),
  });
};

export const updateDriverMutation = (
  options?: Partial<Options<UpdateDriverData>>,
): UseMutationOptions<
  UpdateDriverResponse,
  UpdateDriverError,
  Options<UpdateDriverData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateDriverResponse,
    UpdateDriverError,
    Options<UpdateDriverData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateDriver({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const requestMagicLinkQueryKey = (
  options: Options<RequestMagicLinkData>,
) => createQueryKey("requestMagicLink", options);

export const requestMagicLinkOptions = (
  options: Options<RequestMagicLinkData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await requestMagicLink({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: requestMagicLinkQueryKey(options),
  });
};

export const requestMagicLinkMutation = (
  options?: Partial<Options<RequestMagicLinkData>>,
): UseMutationOptions<
  RequestMagicLinkResponse,
  RequestMagicLinkError,
  Options<RequestMagicLinkData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestMagicLinkResponse,
    RequestMagicLinkError,
    Options<RequestMagicLinkData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await requestMagicLink({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const verifyMagicLinkQueryKey = (
  options: Options<VerifyMagicLinkData>,
) => createQueryKey("verifyMagicLink", options);

export const verifyMagicLinkOptions = (
  options: Options<VerifyMagicLinkData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await verifyMagicLink({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: verifyMagicLinkQueryKey(options),
  });
};

export const verifyMagicLinkMutation = (
  options?: Partial<Options<VerifyMagicLinkData>>,
): UseMutationOptions<
  VerifyMagicLinkResponse,
  VerifyMagicLinkError,
  Options<VerifyMagicLinkData>
> => {
  const mutationOptions: UseMutationOptions<
    VerifyMagicLinkResponse,
    VerifyMagicLinkError,
    Options<VerifyMagicLinkData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await verifyMagicLink({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const verifyMagicLinkTokenQueryKey = (
  options: Options<VerifyMagicLinkTokenData>,
) => createQueryKey("verifyMagicLinkToken", options);

export const verifyMagicLinkTokenOptions = (
  options: Options<VerifyMagicLinkTokenData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await verifyMagicLinkToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: verifyMagicLinkTokenQueryKey(options),
  });
};

export const verifyMagicLinkTokenMutation = (
  options?: Partial<Options<VerifyMagicLinkTokenData>>,
): UseMutationOptions<
  VerifyMagicLinkTokenResponse,
  VerifyMagicLinkTokenError,
  Options<VerifyMagicLinkTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    VerifyMagicLinkTokenResponse,
    VerifyMagicLinkTokenError,
    Options<VerifyMagicLinkTokenData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await verifyMagicLinkToken({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDriverActiveTransactionQueryKey = (
  options?: Options<GetDriverActiveTransactionData>,
) => createQueryKey("getDriverActiveTransaction", options);

export const getDriverActiveTransactionOptions = (
  options?: Options<GetDriverActiveTransactionData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriverActiveTransaction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDriverActiveTransactionQueryKey(options),
  });
};

export const getDriverTransactionMeasurementsQueryKey = (
  options?: Options<GetDriverTransactionMeasurementsData>,
) => createQueryKey("getDriverTransactionMeasurements", options);

export const getDriverTransactionMeasurementsOptions = (
  options?: Options<GetDriverTransactionMeasurementsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriverTransactionMeasurements({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDriverTransactionMeasurementsQueryKey(options),
  });
};

export const submitDriverInputQueryKey = (
  options: Options<SubmitDriverInputData>,
) => createQueryKey("submitDriverInput", options);

export const submitDriverInputOptions = (
  options: Options<SubmitDriverInputData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await submitDriverInput({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: submitDriverInputQueryKey(options),
  });
};

export const submitDriverInputMutation = (
  options?: Partial<Options<SubmitDriverInputData>>,
): UseMutationOptions<
  SubmitDriverInputResponse,
  SubmitDriverInputError,
  Options<SubmitDriverInputData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitDriverInputResponse,
    SubmitDriverInputError,
    Options<SubmitDriverInputData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await submitDriverInput({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDriverScheduleQueryKey = (
  options?: Options<GetDriverScheduleData>,
) => createQueryKey("getDriverSchedule", options);

export const getDriverScheduleOptions = (
  options?: Options<GetDriverScheduleData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDriverSchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDriverScheduleQueryKey(options),
  });
};

export const getEvVehicleMakesQueryKey = (
  options?: Options<GetEvVehicleMakesData>,
) => createQueryKey("getEvVehicleMakes", options);

export const getEvVehicleMakesOptions = (
  options?: Options<GetEvVehicleMakesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvVehicleMakes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvVehicleMakesQueryKey(options),
  });
};

export const getEvVehicleModelsQueryKey = (
  options: Options<GetEvVehicleModelsData>,
) => createQueryKey("getEvVehicleModels", options);

export const getEvVehicleModelsOptions = (
  options: Options<GetEvVehicleModelsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvVehicleModels({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvVehicleModelsQueryKey(options),
  });
};

export const getEvVehicleVariantsQueryKey = (
  options: Options<GetEvVehicleVariantsData>,
) => createQueryKey("getEvVehicleVariants", options);

export const getEvVehicleVariantsOptions = (
  options: Options<GetEvVehicleVariantsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvVehicleVariants({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvVehicleVariantsQueryKey(options),
  });
};

export const getEvVehicleQueryKey = (options: Options<GetEvVehicleData>) =>
  createQueryKey("getEvVehicle", options);

export const getEvVehicleOptions = (options: Options<GetEvVehicleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEvVehicle({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getEvVehicleQueryKey(options),
  });
};

export const pxcAdminRouterCreateTokenV1PxcTokensPostQueryKey = (
  options: Options<PxcAdminRouterCreateTokenV1PxcTokensPostData>,
) => createQueryKey("pxcAdminRouterCreateTokenV1PxcTokensPost", options);

export const pxcAdminRouterCreateTokenV1PxcTokensPostOptions = (
  options: Options<PxcAdminRouterCreateTokenV1PxcTokensPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await pxcAdminRouterCreateTokenV1PxcTokensPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: pxcAdminRouterCreateTokenV1PxcTokensPostQueryKey(options),
  });
};

export const pxcAdminRouterCreateTokenV1PxcTokensPostMutation = (
  options?: Partial<Options<PxcAdminRouterCreateTokenV1PxcTokensPostData>>,
): UseMutationOptions<
  PxcAdminRouterCreateTokenV1PxcTokensPostResponse,
  PxcAdminRouterCreateTokenV1PxcTokensPostError,
  Options<PxcAdminRouterCreateTokenV1PxcTokensPostData>
> => {
  const mutationOptions: UseMutationOptions<
    PxcAdminRouterCreateTokenV1PxcTokensPostResponse,
    PxcAdminRouterCreateTokenV1PxcTokensPostError,
    Options<PxcAdminRouterCreateTokenV1PxcTokensPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await pxcAdminRouterCreateTokenV1PxcTokensPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const pxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteMutation = (
  options?: Partial<
    Options<PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteData>
  >,
): UseMutationOptions<
  PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteResponse,
  PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteError,
  Options<PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteResponse,
    PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteError,
    Options<PxcAdminRouterDeleteTokenV1PxcTokensTokenIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await pxcAdminRouterDeleteTokenV1PxcTokensTokenIdDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOcppConfigurationsQueryKey = (
  options?: Options<GetOcppConfigurationsData>,
) => createQueryKey("getOcppConfigurations", options);

export const getOcppConfigurationsOptions = (
  options?: Options<GetOcppConfigurationsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOcppConfigurations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOcppConfigurationsQueryKey(options),
  });
};

export const createOcppConfigurationQueryKey = (
  options: Options<CreateOcppConfigurationData>,
) => createQueryKey("createOcppConfiguration", options);

export const createOcppConfigurationOptions = (
  options: Options<CreateOcppConfigurationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createOcppConfiguration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createOcppConfigurationQueryKey(options),
  });
};

export const createOcppConfigurationMutation = (
  options?: Partial<Options<CreateOcppConfigurationData>>,
): UseMutationOptions<
  CreateOcppConfigurationResponse,
  CreateOcppConfigurationError,
  Options<CreateOcppConfigurationData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateOcppConfigurationResponse,
    CreateOcppConfigurationError,
    Options<CreateOcppConfigurationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createOcppConfiguration({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOcppActiveSocketsForSiteQueryKey = (
  options: Options<GetOcppActiveSocketsForSiteData>,
) => createQueryKey("getOcppActiveSocketsForSite", options);

export const getOcppActiveSocketsForSiteOptions = (
  options: Options<GetOcppActiveSocketsForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOcppActiveSocketsForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOcppActiveSocketsForSiteQueryKey(options),
  });
};

export const getOcppConfigurationQueryKey = (
  options: Options<GetOcppConfigurationData>,
) => createQueryKey("getOcppConfiguration", options);

export const getOcppConfigurationOptions = (
  options: Options<GetOcppConfigurationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOcppConfiguration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOcppConfigurationQueryKey(options),
  });
};

export const deleteOcppConfigurationMutation = (
  options?: Partial<Options<DeleteOcppConfigurationData>>,
): UseMutationOptions<
  unknown,
  DeleteOcppConfigurationError,
  Options<DeleteOcppConfigurationData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteOcppConfigurationError,
    Options<DeleteOcppConfigurationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteOcppConfiguration({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateOcppConfigurationMutation = (
  options?: Partial<Options<UpdateOcppConfigurationData>>,
): UseMutationOptions<
  UpdateOcppConfigurationResponse,
  UpdateOcppConfigurationError,
  Options<UpdateOcppConfigurationData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateOcppConfigurationResponse,
    UpdateOcppConfigurationError,
    Options<UpdateOcppConfigurationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateOcppConfiguration({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateSocketToAssetMapMutation = (
  options?: Partial<Options<UpdateSocketToAssetMapData>>,
): UseMutationOptions<
  UpdateSocketToAssetMapResponse,
  UpdateSocketToAssetMapError,
  Options<UpdateSocketToAssetMapData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateSocketToAssetMapResponse,
    UpdateSocketToAssetMapError,
    Options<UpdateSocketToAssetMapData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateSocketToAssetMap({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSocketMappingSuggestionsQueryKey = (
  options: Options<GetSocketMappingSuggestionsData>,
) => createQueryKey("getSocketMappingSuggestions", options);

export const getSocketMappingSuggestionsOptions = (
  options: Options<GetSocketMappingSuggestionsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSocketMappingSuggestions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSocketMappingSuggestionsQueryKey(options),
  });
};

export const listOcppMessagesQueryKey = (
  options: Options<ListOcppMessagesData>,
) => createQueryKey("listOcppMessages", options);

export const listOcppMessagesOptions = (
  options: Options<ListOcppMessagesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listOcppMessages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listOcppMessagesQueryKey(options),
  });
};

export const listOcppMessagesInfiniteQueryKey = (
  options: Options<ListOcppMessagesData>,
): QueryKey<Options<ListOcppMessagesData>> =>
  createQueryKey("listOcppMessages", options, true);

export const listOcppMessagesInfiniteOptions = (
  options: Options<ListOcppMessagesData>,
) => {
  return infiniteQueryOptions<
    ListOcppMessagesResponse,
    ListOcppMessagesError,
    InfiniteData<ListOcppMessagesResponse>,
    QueryKey<Options<ListOcppMessagesData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ListOcppMessagesData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListOcppMessagesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listOcppMessages({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listOcppMessagesInfiniteQueryKey(options),
    },
  );
};

export const diagnoseOcppTransactionLinkingQueryKey = (
  options: Options<DiagnoseOcppTransactionLinkingData>,
) => createQueryKey("diagnoseOcppTransactionLinking", options);

export const diagnoseOcppTransactionLinkingOptions = (
  options: Options<DiagnoseOcppTransactionLinkingData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await diagnoseOcppTransactionLinking({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: diagnoseOcppTransactionLinkingQueryKey(options),
  });
};

export const benefitReportRouterListReportsV1BenefitReportsSiteIdGetQueryKey = (
  options: Options<BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData>,
) =>
  createQueryKey(
    "benefitReportRouterListReportsV1BenefitReportsSiteIdGet",
    options,
  );

export const benefitReportRouterListReportsV1BenefitReportsSiteIdGetOptions = (
  options: Options<BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await benefitReportRouterListReportsV1BenefitReportsSiteIdGet({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      benefitReportRouterListReportsV1BenefitReportsSiteIdGetQueryKey(options),
  });
};

export const benefitReportRouterListReportsV1BenefitReportsSiteIdGetInfiniteQueryKey =
  (
    options: Options<BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData>,
  ): QueryKey<
    Options<BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData>
  > =>
    createQueryKey(
      "benefitReportRouterListReportsV1BenefitReportsSiteIdGet",
      options,
      true,
    );

export const benefitReportRouterListReportsV1BenefitReportsSiteIdGetInfiniteOptions =
  (
    options: Options<BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData>,
  ) => {
    return infiniteQueryOptions<
      BenefitReportRouterListReportsV1BenefitReportsSiteIdGetResponse,
      BenefitReportRouterListReportsV1BenefitReportsSiteIdGetError,
      InfiniteData<BenefitReportRouterListReportsV1BenefitReportsSiteIdGetResponse>,
      QueryKey<
        Options<BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData>
      >,
      | string
      | null
      | Pick<
          QueryKey<
            Options<BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData>
          >[0],
          "body" | "headers" | "path" | "query"
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<BenefitReportRouterListReportsV1BenefitReportsSiteIdGetData>
            >[0],
            "body" | "headers" | "path" | "query"
          > =
            typeof pageParam === "object"
              ? pageParam
              : {
                  query: {
                    after: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } =
            await benefitReportRouterListReportsV1BenefitReportsSiteIdGet({
              ...options,
              ...params,
              signal,
              throwOnError: true,
            });
          return data;
        },
        queryKey:
          benefitReportRouterListReportsV1BenefitReportsSiteIdGetInfiniteQueryKey(
            options,
          ),
      },
    );
  };

export const benefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetQueryKey =
  (
    options: Options<BenefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetData>,
  ) =>
    createQueryKey(
      "benefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGet",
      options,
    );

export const benefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetOptions =
  (
    options: Options<BenefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await benefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
          });
        return data;
      },
      queryKey:
        benefitReportRouterGetReportV1BenefitReportsSiteIdYearMonthGetQueryKey(
          options,
        ),
    });
  };

export const alertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetQueryKey =
  (
    options?: Options<AlertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetData>,
  ) =>
    createQueryKey(
      "alertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGet",
      options,
    );

export const alertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetOptions =
  (
    options?: Options<AlertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await alertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGet(
            {
              ...options,
              ...queryKey[0],
              signal,
              throwOnError: true,
            },
          );
        return data;
      },
      queryKey:
        alertSubscriptionRouterListAlertSubscriptionsV1AlertSubscriptionsGetQueryKey(
          options,
        ),
    });
  };

export const alertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostQueryKey =
  (
    options: Options<AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostData>,
  ) =>
    createQueryKey(
      "alertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPost",
      options,
    );

export const alertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostOptions =
  (
    options: Options<AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await alertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPost(
            {
              ...options,
              ...queryKey[0],
              signal,
              throwOnError: true,
            },
          );
        return data;
      },
      queryKey:
        alertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostQueryKey(
          options,
        ),
    });
  };

export const alertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostMutation =
  (
    options?: Partial<
      Options<AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostData>
    >,
  ): UseMutationOptions<
    AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostResponse,
    AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostError,
    Options<AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostResponse,
      AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostError,
      Options<AlertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPostData>
    > = {
      mutationFn: async (localOptions) => {
        const { data } =
          await alertSubscriptionRouterCreateAlertSubscriptionV1AlertSubscriptionsPost(
            {
              ...options,
              ...localOptions,
              throwOnError: true,
            },
          );
        return data;
      },
    };
    return mutationOptions;
  };

export const alertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteMutation =
  (
    options?: Partial<
      Options<AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteData>
    >,
  ): UseMutationOptions<
    unknown,
    AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteError,
    Options<AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteData>
  > => {
    const mutationOptions: UseMutationOptions<
      unknown,
      AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteError,
      Options<AlertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDeleteData>
    > = {
      mutationFn: async (localOptions) => {
        const { data } =
          await alertSubscriptionRouterDeleteAlertSubscriptionV1AlertSubscriptionsIdDelete(
            {
              ...options,
              ...localOptions,
              throwOnError: true,
            },
          );
        return data;
      },
    };
    return mutationOptions;
  };

export const alertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetQueryKey =
  (
    options: Options<AlertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetData>,
  ) =>
    createQueryKey(
      "alertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGet",
      options,
    );

export const alertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetOptions =
  (
    options: Options<AlertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetData>,
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await alertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGet(
            {
              ...options,
              ...queryKey[0],
              signal,
              throwOnError: true,
            },
          );
        return data;
      },
      queryKey:
        alertSubscriptionRouterGetAlertSubscriptionV1AlertSubscriptionsIdGetQueryKey(
          options,
        ),
    });
  };

export const alertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutMutation =
  (
    options?: Partial<
      Options<AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutData>
    >,
  ): UseMutationOptions<
    AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutResponse,
    AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutError,
    Options<AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutData>
  > => {
    const mutationOptions: UseMutationOptions<
      AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutResponse,
      AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutError,
      Options<AlertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPutData>
    > = {
      mutationFn: async (localOptions) => {
        const { data } =
          await alertSubscriptionRouterUpdateAlertSubscriptionV1AlertSubscriptionsIdPut(
            {
              ...options,
              ...localOptions,
              throwOnError: true,
            },
          );
        return data;
      },
    };
    return mutationOptions;
  };

export const requestSiteGoLiveQueryKey = (
  options: Options<RequestSiteGoLiveData>,
) => createQueryKey("requestSiteGoLive", options);

export const requestSiteGoLiveOptions = (
  options: Options<RequestSiteGoLiveData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await requestSiteGoLive({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: requestSiteGoLiveQueryKey(options),
  });
};

export const requestSiteGoLiveMutation = (
  options?: Partial<Options<RequestSiteGoLiveData>>,
): UseMutationOptions<
  RequestSiteGoLiveResponse,
  RequestSiteGoLiveError,
  Options<RequestSiteGoLiveData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestSiteGoLiveResponse,
    RequestSiteGoLiveError,
    Options<RequestSiteGoLiveData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await requestSiteGoLive({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
